import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = "/api";

const MARKETPLACES = [
  { id: "allegro-pl", label: "Allegro PL" },
  { id: "allegro-business-pl", label: "Allegro Business PL" },
  { id: "allegro-cz", label: "Allegro CZ" },
  { id: "allegro-sk", label: "Allegro SK" },
  { id: "allegro-hu", label: "Allegro HU" },
  { id: "allegro-business-cz", label: "Allegro Business CZ" },
];

const PER_ACCOUNT_PARAM_IDS = ["237206","234493","243973","249034","215941","227345"];

const PROVINCE_OPTIONS = [
  { value: "DOLNOSLASKIE", label: "dolnośląskie" },
  { value: "KUJAWSKO_POMORSKIE", label: "kujawsko-pomorskie" },
  { value: "LUBELSKIE", label: "lubelskie" },
  { value: "LUBUSKIE", label: "lubuskie" },
  { value: "LODZKIE", label: "łódzkie" },
  { value: "MALOPOLSKIE", label: "małopolskie" },
  { value: "MAZOWIECKIE", label: "mazowieckie" },
  { value: "OPOLSKIE", label: "opolskie" },
  { value: "PODKARPACKIE", label: "podkarpackie" },
  { value: "PODLASKIE", label: "podlaskie" },
  { value: "POMORSKIE", label: "pomorskie" },
  { value: "SLASKIE", label: "śląskie" },
  { value: "SWIETOKRZYSKIE", label: "świętokrzyskie" },
  { value: "WARMINSKO_MAZURSKIE", label: "warmińsko-mazurskie" },
  { value: "WIELKOPOLSKIE", label: "wielkopolskie" },
  { value: "ZACHODNIOPOMORSKIE", label: "zachodniopomorskie" },
];

const HANDLING_OPTIONS = [
  { value: "PT0S", label: "Natychmiast" }, { value: "P1D", label: "1 dzień" },
  { value: "P2D", label: "2 dni" }, { value: "P3D", label: "3 dni" },
  { value: "P5D", label: "5 dni" }, { value: "P7D", label: "7 dni" },
  { value: "P14D", label: "14 dni" }, { value: "P21D", label: "21 dni" },
  { value: "P30D", label: "30 dni" },
];
const INVOICE_OPTIONS = [
  { value: "VAT", label: "Faktura VAT" },
  { value: "VAT_MARGIN", label: "Faktura marża" },
  { value: "WITHOUT_VAT", label: "Bez faktury" },
];
const s: any = {
  btn: { border: "none", borderRadius: 6, padding: "7px 14px", fontSize: 12, cursor: "pointer", fontWeight: 500 },
  input: { border: "1px solid #d1d5db", borderRadius: 6, padding: "7px 10px", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" as const },
  label: { fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4, fontWeight: 500 },
  card: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: 16, marginBottom: 12 },
  stepBtn: (active: boolean) => ({ padding: "6px 16px", borderRadius: 6, border: active ? "2px solid #1d4ed8" : "1px solid #d1d5db", background: active ? "#eff6ff" : "#fff", color: active ? "#1d4ed8" : "#6b7280", fontWeight: active ? 700 : 400, fontSize: 12, cursor: "pointer" }),
};

interface ImageItem { url: string; preview: string; uploading?: boolean; }
interface AccountConfig {
  account_id: string;
  account_name: string;
  enabled: boolean;
  main_image_url: string;
  extra_images: string[];
  _showPicker?: boolean;
  _showPickerVar?: string;
  title: string;
  description: string;
  sku: string;
  responsible_producer_id: string;
  responsible_person_id: string;
  safety_info_template: string;
  price: string;
  stock: string;
  shipping_rates_id: string;
  return_policy_id: string;
  implied_warranty_id: string;
  warranty_id: string;
  invoice: string;
  location_city: string;
  location_province: string;
  location_zip: string;
  handling_time: string;
  marketed_before_gpsr: boolean;
  publication_duration: string;
  param_model: string;
  param_zamienniki: string;
  param_oryginal: string;
}

// NEW: typ dla zdjęć per wariant
interface VariantImageConfig { main: string; extra: string[]; }

interface OfferCreateProps { onBack: () => void; }

export default function OfferCreate({ onBack }: OfferCreateProps) {
  const [step, setStep] = useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [accounts, setAccounts] = useState<any[]>([]);
  const [profiles, setProfiles] = useState<any[]>([]);
  const [templates, setTemplates] = useState<any[]>([]);
  const [accountConfigs, setAccountConfigs] = useState<AccountConfig[]>([]);

  // Zdjecia
  const [images, setImages] = useState<ImageItem[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Kategoria
  const [categoryId, setCategoryId] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryPath, setCategoryPath] = useState("");
  const [catMode, setCatMode] = useState<"mine"|"search">("mine");
  const [mineCategories, setMineCategories] = useState<any[]>([]);
  const [searchPhrase, setSearchPhrase] = useState("");
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [browseResults, setBrowseResults] = useState<any[]>([]);
  const [breadcrumb, setBreadcrumb] = useState<{id:string;name:string}[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [productSearch, setProductSearch] = useState("");
  const [productResults, setProductResults] = useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  // Opis
  const [context, setContext] = useState("");
  const [categoryParams, setCategoryParams] = useState<{required:any[];optional:any[]}>({required:[],optional:[]});
  const [paramValues, setParamValues] = useState<Record<string,any>>({});
  const [selectedMarketplaces, setSelectedMarketplaces] = useState<string[]>(["allegro-pl"]);
  const [messageToSeller, setMessageToSeller] = useState<string>("OPTIONAL");
  const [republish, setRepublish] = useState<boolean>(true);
  const [vatRates, setVatRates] = useState<Record<string,string>>({
    PL: "23.00", CZ: "21.00", SK: "23.00", HU: "27.00", LT: "21.00"
  });
  const [paramCustomValues, setParamCustomValues] = useState<Record<string,string>>({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [generatingAI, setGeneratingAI] = useState(false);
  const [generatingTitles, setGeneratingTitles] = useState(false);
  const [generatingDesc, setGeneratingDesc] = useState(false);
  const [sameDescForAll, setSameDescForAll] = useState(true);
  const [previewDesc, setPreviewDesc] = useState<string|null>(null);

  // Wystawianie
  const [publishing, setPublishing] = useState(false);
  const [showSafetyModal, setShowSafetyModal] = useState(false);
  const [newSafetyText, setNewSafetyText] = useState("");
  const [newSafetyName, setNewSafetyName] = useState("");
  const [savingSafety, setSavingSafety] = useState(false);
  const [publishResults, setPublishResults] = useState<any[]>([]);
  const [publishError, setPublishError] = useState("");

  // NEW: Warianty
  const [offerMode, setOfferMode] = useState<"single" | "variants">("single");
  const [variantMode, setVariantMode] = useState<"custom" | "param">("custom");
  const [customVariantNames, setCustomVariantNames] = useState<string[]>(["", ""]);
  const [variantParamId, setVariantParamId] = useState("");
  const [selectedVariantValueIds, setSelectedVariantValueIds] = useState<string[]>([]);
  const [variantImages, setVariantImages] = useState<Record<string, Record<string, VariantImageConfig>>>({}); // variantId -> accountId -> {main, extra}
  const [variantShowPicker, setVariantShowPicker] = useState<Record<string, boolean>>({});
  const [variantEan, setVariantEan] = useState<Record<string, string>>({});
  const [variantDesc, setVariantDesc] = useState<Record<string, string>>({});
  const [variantParamOverrides, setVariantParamOverrides] = useState<Record<string, Record<string, string>>>({}); // variantId -> paramId -> value
  const [variantTitle, setVariantTitle] = useState<Record<string, string>>({}); // variantId -> tytul (nadpisuje bazowy+doklejke)
  const [variantSku, setVariantSku] = useState<Record<string, string>>({}); // variantId -> SKU (puste = wspolny cfg.sku + nazwa)
  const [variantPrice, setVariantPrice] = useState<Record<string, string>>({}); // variantId -> cena (puste = wspolna cfg.price)
  const [variantStock, setVariantStock] = useState<Record<string, string>>({}); // variantId -> stan (puste = wspolny cfg.stock)
  const [generatingVariantData, setGeneratingVariantData] = useState(false);

  useEffect(() => {
    Promise.all([
      axios.get(API + "/allegro/accounts"),
      axios.get(API + "/sales-profiles"),
      axios.get(API + "/offer-templates"),
    ]).then(([accR, profR, tmplR]) => {
      const accs = accR.data || [];
      const profs = profR.data || [];
      setAccounts(accs);
      setProfiles(profs);
      setTemplates(tmplR.data || []);
      const configs: AccountConfig[] = accs.map((a: any) => {
        const prof = profs.find((p: any) => p.account_id === a.id)?.profile;
        return {
          account_id: a.id,
          account_name: a.name,
          enabled: false,
          main_image_url: "",
          extra_images: [],
          _showPicker: false,
          title: "",
          description: "",
          sku: "",
          responsible_producer_id: prof?.responsible_producers?.[0]?.id || "",
          responsible_person_id: prof?.responsible_persons?.[0]?.id || "",
          safety_info_template: "",
          price: "",
          stock: "1",
          shipping_rates_id: prof?.shipping_rates?.[0]?.id || "",
          return_policy_id: prof?.return_policies?.[0]?.id || "",
          implied_warranty_id: prof?.implied_warranties?.[0]?.id || "",
          warranty_id: prof?.warranties?.[0]?.id || "",
          invoice: prof?.default_invoice === "margin" ? "VAT_MARGIN" : prof?.default_invoice === "none" ? "WITHOUT_VAT" : "VAT",
          location_city: prof?.default_location_city || "",
          location_province: prof?.default_location_province || "MAZOWIECKIE",
          location_zip: prof?.default_location_zip || "",
          handling_time: "PT0S",
          marketed_before_gpsr: true,
          publication_duration: "",
          param_model: "",
          param_zamienniki: "",
          param_oryginal: "",
        };
      });
      setAccountConfigs(configs);
    });
  }, []);

  const validateStep = (fromStep: number): string | null => {
    if (fromStep === 1) {
      if (enabledAccounts.length === 0) return "Zaznacz co najmniej jedno konto.";
      if (uploadedImages.filter(i => i.url).length === 0) return "Dodaj co najmniej jedno zdjecie.";
    }
    if (fromStep === 2) {
      if (!categoryId) return "Wybierz kategorie.";
      // NEW: walidacja wariantów
      if (offerMode === "variants") {
        if (variantMode === "custom") {
          const filled = customVariantNames.filter((n: string) => n.trim() !== "");
          if (filled.length < 2) return "Wpisz co najmniej 2 nazwy wariantów.";
        } else {
          if (!variantParamId) return "Wybierz parametr wariantów.";
          if (selectedVariantValueIds.length < 2) return "Wybierz co najmniej 2 wartości wariantów.";
        }
      }
    }
    if (fromStep === 3) {
      // W trybie wariantow EAN jest ustawiany per wariant (sekcja "Dane per wariant") - wyklucz go z walidacji wspolnej
      // Zbierz parametry nadpisane per wariant (ustawione dla KAZDEGO wariantu) - te sa spelnione per wariant, nie musza byc wspolne
      const overriddenForAllVariants = (pid: string) => offerMode === "variants" && selectedVariantValues.length > 0
        && selectedVariantValues.every(v => String((variantParamOverrides[v.id] || {})[pid] || "").trim() !== "");
      const missing = categoryParams.required.filter((p: any) => {
        const empty = !paramValues[p.id] || paramValues[p.id] === "";
        if (!empty) return false;
        if (offerMode === "variants" && /ean|gtin|kod produktu/i.test(p.name || "")) return false; // EAN per wariant
        if (overriddenForAllVariants(p.id)) return false; // parametr nadpisany dla wszystkich wariantow
        if (PER_ACCOUNT_PARAM_IDS.includes(p.id)) return false; // wpisywany per konto w kroku 5 (sprawdzany przy wystawianiu)
        return true;
      });
      if (missing.length > 0) return "Uzupelnij wymagane parametry: " + missing.map((p:any) => p.name).join(", ");
      // Tytul: w trybie wariantow wystarczy tytul per wariant (lub bazowy per konto). Nie wymagaj wspolnego jesli warianty maja tytuly.
      if (offerMode === "variants") {
        const everyVariantHasTitle = selectedVariantValues.length > 0 && selectedVariantValues.every(v => (variantTitle[v.id]||"").trim());
        const anyBaseTitle = enabledAccounts.some(c => (c.title||"").trim());
        if (!everyVariantHasTitle && !anyBaseTitle) return "Uzupelnij tytul: w sekcji wariantow (per wariant) albo bazowy dla konta.";
      } else {
        if (enabledAccounts.every(c => !(c.title||"").trim())) return "Uzupelnij tytul oferty dla co najmniej jednego konta.";
      }
    }
    if (fromStep === 4) {
      const missingDelivery = enabledAccounts.filter(c => !c.shipping_rates_id);
      if (missingDelivery.length > 0) return "Uzupelnij cennik dostawy dla kont: " + missingDelivery.map((c:any) => c.account_name).join(", ");
      const missingReturn = enabledAccounts.filter(c => !c.return_policy_id);
      if (missingReturn.length > 0) return "Uzupelnij warunki zwrotow dla kont: " + missingReturn.map((c:any) => c.account_name).join(", ");
      const missingWarranty = enabledAccounts.filter(c => !c.implied_warranty_id);
      if (missingWarranty.length > 0) return "Uzupelnij reklamacje (rekojmia) dla kont: " + missingWarranty.map((c:any) => c.account_name).join(", ");
      const missingProducer = enabledAccounts.filter(c => !c.responsible_producer_id);
      if (missingProducer.length > 0) return "Uzupelnij GPSR - producenta odpowiedzialnego dla kont: " + missingProducer.map((c:any) => c.account_name).join(", ");
      const missingPerson = enabledAccounts.filter(c => !c.responsible_person_id);
      if (missingPerson.length > 0) return "Uzupelnij GPSR - osobe odpowiedzialna dla kont: " + missingPerson.map((c:any) => c.account_name).join(", ");
      const missingSafety = enabledAccounts.filter(c => !c.safety_info_template);
      if (missingSafety.length > 0) return "Uzupelnij informacje o bezpieczenstwie dla kont: " + missingSafety.map((c:any) => c.account_name).join(", ");
    }
    return null;
  };

  const goToStep = (targetStep: number) => {
    if (targetStep > step) {
      for (let s = step; s < targetStep; s++) {
        const err = validateStep(s);
        if (err) { alert(err); return; }
      }
    }
    setStep(targetStep);
  };

  const updateConfig = (account_id: string, field: string, value: any) => {
    setAccountConfigs(prev => prev.map(c => c.account_id === account_id ? {...c, [field]: value} : c));
  };

  // Zdjecia wariantu per konto: zapis pola (main/extra) dla danego wariantu i konta
  const updateVariantImage = (variantId: string, accountId: string, field: "main" | "extra", value: any) => {
    setVariantImages(prev => {
      const perVar = prev[variantId] || {};
      const perAcc = perVar[accountId] || { main: "", extra: [] };
      return { ...prev, [variantId]: { ...perVar, [accountId]: { ...perAcc, [field]: value } } };
    });
  };

  // Kopiuj zdjecia wariantu z jednego konta do WSZYSTKICH wlaczonych kont (wygoda przy wielu kontach)
  const copyVariantImagesToAll = (variantId: string, fromAccountId: string) => {
    setVariantImages(prev => {
      const perVar = prev[variantId] || {};
      const source = perVar[fromAccountId] || { main: "", extra: [] };
      const nextPerVar: Record<string, VariantImageConfig> = { ...perVar };
      for (const acc of enabledAccounts) {
        nextPerVar[acc.account_id] = { main: source.main, extra: [...(source.extra || [])] };
      }
      return { ...prev, [variantId]: nextPerVar };
    });
  };

  const autofillOthers = (account_id: string, field: string, value: any) => {
    const DEFAULT_VALUES: Record<string, string> = { stock: "1", price: "", sku: "", param_model: "", param_zamienniki: "", param_oryginal: "" };
    setAccountConfigs(prev => prev.map(c => {
      if (c.account_id === account_id) return c;
      const currentVal = String(c[field as keyof typeof c] ?? "");
      const defaultVal = DEFAULT_VALUES[field] ?? "";
      if (currentVal === defaultVal || currentVal === "") {
        return {...c, [field]: value};
      }
      return c;
    }));
  };

  const enabledAccounts = accountConfigs.filter(c => c.enabled);

  // NEW: computed values dla wariantów
  const allCategoryParams = [...categoryParams.required, ...categoryParams.optional];
  const variantParam = variantParamId ? allCategoryParams.find((p: any) => p.id === variantParamId) : null;
  const allowedVariantParams = allCategoryParams.filter((p: any) => p.options?.variantsAllowed === true && p.dictionary?.length > 0);

  // Warianty z parametru kategorii
  const selectedVariantValuesFromParam: {id: string; name: string}[] = (variantParam?.dictionary || [])
    .filter((d: any) => selectedVariantValueIds.includes(d.id))
    .map((d: any) => ({ id: d.id, name: d.name }));

  // Warianty własne — filtrujemy puste, tworzymy pseudo-id z nazwy
  const selectedVariantValuesCustom: {id: string; name: string}[] = customVariantNames
    .map((n: string, idx: number) => ({ id: "custom_" + idx, name: n.trim() }))
    .filter((v) => v.name !== "");

  // Aktywne warianty zależnie od trybu
  const selectedVariantValues: {id: string; name: string}[] =
    variantMode === "custom" ? selectedVariantValuesCustom : selectedVariantValuesFromParam;

  // Upload zdjec
  const uploadImages = async (files: FileList) => {
    const enabledIds = accountConfigs.filter(c => c.enabled).map(c => c.account_id);
    if (enabledIds.length === 0) { alert("Najpierw zaznacz konta na których chcesz wystawić ofertę"); return; }
    const firstAccountId = enabledIds[0];
    const newImages: ImageItem[] = Array.from(files).map(f => ({ url: "", preview: URL.createObjectURL(f), uploading: true }));
    const startIdx = images.length;
    setImages(prev => [...prev, ...newImages]);
    for (let i = 0; i < files.length; i++) {
      try {
        const fd = new FormData();
        fd.append("account_id", firstAccountId);
        fd.append("file", files[i]);
        const r = await axios.post(API + "/offers/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } });
        const uploadedUrl = r.data.url;
        setImages(prev => prev.map((img, j) => j === startIdx + i ? {...img, url: uploadedUrl, uploading: false} : img));
        setAccountConfigs(prev => prev.map(c => c.enabled ? {...c, extra_images: [...(c.extra_images||[]), uploadedUrl]} : c));
      } catch {
        setImages(prev => prev.map((img, j) => j === startIdx + i ? {...img, uploading: false, url: "ERROR"} : img));
      }
    }
  };

  const removeImage = (idx: number) => {
    const removedUrl = images[idx]?.url;
    setImages(prev => prev.filter((_, j) => j !== idx));
    if (removedUrl) {
      setAccountConfigs(prev => prev.map(c => ({
        ...c,
        main_image_url: c.main_image_url === removedUrl ? "" : c.main_image_url,
        extra_images: (c.extra_images || []).filter((u: string) => u !== removedUrl)
      })));
      // NEW: usuń zdjęcie z konfiguracji wariantów
      setVariantImages(prev => {
        const updated: Record<string, Record<string, VariantImageConfig>> = {};
        for (const [vid, perAcc] of Object.entries(prev)) {
          updated[vid] = {};
          for (const [aid, vi] of Object.entries(perAcc || {})) {
            updated[vid][aid] = {
              main: vi.main === removedUrl ? "" : vi.main,
              extra: (vi.extra || []).filter((u: string) => u !== removedUrl),
            };
          }
        }
        return updated;
      });
    }
  };

  const uploadedImages = images.filter(i => i.url && i.url !== "ERROR");

  // Kategoria
  const loadMineCategories = async () => { try { const r = await axios.get(API + "/allegro/categories/from-offers"); setMineCategories(r.data); } catch {} };
  const searchLocalCats = async (phrase: string) => { if (phrase.length < 2) { setSearchResults([]); return; } try { const r = await axios.get(API + "/allegro/categories/local-search", { params: { phrase } }); setSearchResults(r.data); } catch {} };
  const loadChildren = async (parent_id: string = "") => { try { const r = await axios.get(API + "/allegro/categories/local-children", { params: { parent_id } }); setBrowseResults(r.data); } catch {} };

  const loadCategoryParams = async (cat_id: string) => {
    try {
      const paramsRes = await axios.get(API + "/allegro/categories/" + cat_id + "/parameters");
      setCategoryParams(paramsRes.data);
      setParamValues({});
      setParamCustomValues({});
      // NEW: reset wariantów przy zmianie kategorii
      setVariantMode("custom");
      setCustomVariantNames(["", ""]);
      setVariantParamId("");
      setSelectedVariantValueIds([]);
      setVariantImages({});
      setVariantShowPicker({});
    } catch {}
  };

  const selectCategory = async (id: string, name: string, path: string = "") => {
    setCategoryId(id); setCategoryName(name);
    if (path) setCategoryPath(path);
    else { try { const r = await axios.get(API + "/allegro/categories/breadcrumb", { params: { category_id: id } }); setCategoryPath(r.data.slice(0,-1).map((c:any)=>c.name).join(" > ")); } catch {} }
    loadCategoryParams(id);
  };

  const applyTemplate = (t: any) => {
    setSelectedTemplate(t);
    if (t.defaults?.handling_time) setAccountConfigs(prev => prev.map(c => ({...c, handling_time: t.defaults.handling_time})));
    if (categoryId) loadCategoryParams(categoryId);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const generateAI = async (titleOnly = false, descOnly = false) => {
    if (!categoryId || !context) return;
    const firstEnabled = enabledAccounts[0];
    if (!firstEnabled) return;
    setGeneratingAI(true);
    try {
      const paramsObj: Record<string,string> = {};
      allCategoryParams.forEach((p: any) => { if (paramValues[p.id]) { const d = p.dictionary?.find((d:any) => d.id === paramValues[p.id]); paramsObj[p.name] = d ? d.name : paramValues[p.id]; } });
      const r = await axios.post(API + "/offers/generate-text", {
        account_id: firstEnabled.account_id, category_id: categoryId, category_name: categoryName,
        context, parameters: paramsObj, generate_title: !descOnly, generate_description: !titleOnly
      });
      if (!descOnly && r.data.title) setTitle(r.data.title);
      if (!titleOnly && r.data.description) setDescription(r.data.description);
    } catch {}
    setGeneratingAI(false);
  };

  const searchProducts = async (phrase: string) => {
    if (phrase.length < 3 || enabledAccounts.length === 0) { setProductResults([]); return; }
    try { const r = await axios.get(API + "/offers/search-products", { params: { phrase, account_id: enabledAccounts[0].account_id, category_id: categoryId } }); setProductResults(r.data.products || []); } catch {}
  };

  const formatHtmlForTextarea = (html: string): string => {
    return html
      .replace(/></g, ">\n<")
      .replace(/<\/p>/g, "</p>\n")
      .replace(/<\/li>/g, "</li>\n")
      .replace(/<\/ul>/g, "</ul>\n")
      .replace(/<\/ol>/g, "</ol>\n")
      .replace(/<\/h[1-6]>/g, (m: string) => m + "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  };

  const getParamsText = () => {
    const obj: Record<string,string> = {};
    allCategoryParams.forEach((p:any) => {
      if (paramValues[p.id]) {
        const d = p.dictionary?.find((d:any) => d.id === paramValues[p.id]);
        obj[p.name] = d ? d.name : paramValues[p.id];
      }
    });
    return obj;
  };

  const generateParamsFromContext = async () => {
    if (!context || !categoryId) return;
    setGeneratingAI(true);
    try {
      const paramNames = allCategoryParams.map((p:any) => ({ id: p.id, name: p.name, type: p.type, unit: p.unit||"", dictionary: p.dictionary?.map((d:any) => d.name) || [], ambiguousValueId: p.options?.ambiguousValueId || null }));
      const r = await axios.post(API + "/offers/generate-params", {
        context, category_name: categoryName, params: paramNames,
        account_id: enabledAccounts[0]?.account_id || ""
      });
      if (r.data.values) {
        const newVals: Record<string,string> = {...paramValues};
        allCategoryParams.forEach((p:any) => {
          // W trybie wariantow EAN jest per wariant - nie wypelniaj go we wspolnych parametrach
          if (offerMode === "variants" && /ean|gtin|kod produktu/i.test(p.name || "")) return;
          const isQty = p.name.toLowerCase().includes("ilo") || p.name.toLowerCase().includes("sztuk") || p.name.toLowerCase().includes("liczba");
          if (isQty) {
            if (p.type === "dictionary" && p.dictionary?.length > 0) {
              const one = p.dictionary.find((d:any) => d.name.startsWith("1")) || p.dictionary[0];
              if (one) newVals[p.id] = one.id;
            } else { newVals[p.id] = "1"; }
          }
          const val = !isQty && (r.data.values[p.name]
            || r.data.values[p.name.toLowerCase()]
            || Object.entries(r.data.values).find(([k]) => k.toLowerCase().startsWith(p.name.toLowerCase()))?.[1]
            || Object.entries(r.data.values).find(([k]) => p.name.toLowerCase().startsWith(k.toLowerCase()))?.[1]);
          if (val) {
            if (p.type === "dictionary") {
              const d = p.dictionary?.find((d:any) => d.name === val)
                || p.dictionary?.find((d:any) => d.name.toLowerCase() === String(val).toLowerCase());
              if (d) newVals[p.id] = d.id;
            } else {
              newVals[p.id] = String(val);
            }
          }
        });
        setParamValues(newVals);
      }
    } catch {}
    setGeneratingAI(false);
  };

  const generateVariantEansFromContext = async () => {
    if (!context || selectedVariantValues.length === 0) return;
    setGeneratingVariantData(true);
    try {
      const r = await axios.post(API + "/offers/generate-variant-eans", {
        context,
        variant_names: selectedVariantValues.map(v => v.name),
      });
      if (r.data.eans) {
        const newEans: Record<string, string> = { ...variantEan };
        selectedVariantValues.forEach(v => {
          const e = r.data.eans[v.name] || r.data.eans[v.name.toLowerCase()]
            || Object.entries(r.data.eans).find(([k]) => k.toLowerCase() === v.name.toLowerCase())?.[1];
          if (e) newEans[v.id] = String(e);
        });
        setVariantEan(newEans);
      }
    } catch {}
    setGeneratingVariantData(false);
  };

  const generateOneVariantDesc = async (variantId: string, variantName: string) => {
    if (!context) return;
    setGeneratingVariantData(true);
    try {
      const paramsObj = getParamsText();
      const r = await axios.post(API + "/offers/generate-text", {
        account_id: enabledAccounts[0]?.account_id || "", category_id: categoryId,
        context: context + "\n\nUWAGA: opis dotyczy WYLACZNIE wariantu: " + variantName + ". Jesli kontekst wymienia rozne warianty (np. kolory), opisz TYLKO ten wariant, pomin pozostale.",
        category_name: categoryName, parameters: paramsObj,
        generate_title: false, generate_description: true,
      });
      if (r.data.description) {
        setVariantDesc(prev => ({ ...prev, [variantId]: formatHtmlForTextarea(r.data.description) }));
      }
    } catch {}
    setGeneratingVariantData(false);
  };

  const generateOneVariantTitle = async (variantId: string, variantName: string) => {
    if (!context) return;
    setGeneratingVariantData(true);
    try {
      const paramsObj = getParamsText();
      const r = await axios.post(API + "/offers/generate-titles", {
        account_id: enabledAccounts[0]?.account_id || "",
        context: context + "\n\nUWAGA: tytul dotyczy wariantu: " + variantName + ". Uwzglednij te ceche wariantu w tytule.",
        category_name: categoryName, parameters: paramsObj,
        account_names: ["wariant"],
      });
      const t = (r.data.titles && (r.data.titles["wariant"] || Object.values(r.data.titles)[0])) || "";
      if (t) setVariantTitle(prev => ({ ...prev, [variantId]: String(t).substring(0, 75) }));
    } catch {}
    setGeneratingVariantData(false);
  };

  // Jeden przycisk: generuj rownolegle tytuly + opisy + EAN dla WSZYSTKICH wariantow
  const generateAllVariantData = async () => {
    if (!context || selectedVariantValues.length === 0) return;
    setGeneratingVariantData(true);
    try {
      // EAN dla wszystkich (jedno wywolanie mapujace)
      const eanPromise = axios.post(API + "/offers/generate-variant-eans", {
        context, variant_names: selectedVariantValues.map(v => v.name),
      }).then(r => {
        if (r.data.eans) {
          setVariantEan(prev => {
            const next = { ...prev };
            selectedVariantValues.forEach(v => {
              const e = r.data.eans[v.name] || r.data.eans[v.name.toLowerCase()]
                || Object.entries(r.data.eans).find(([k]) => k.toLowerCase() === v.name.toLowerCase())?.[1];
              if (e) next[v.id] = String(e);
            });
            return next;
          });
        }
      }).catch(() => {});
      // Tytul + opis per wariant (rownolegle)
      const paramsObj = getParamsText();
      const perVariant = selectedVariantValues.map(v => {
        const titleP = axios.post(API + "/offers/generate-titles", {
          account_id: enabledAccounts[0]?.account_id || "",
          context: context + "\n\nUWAGA: tytul dotyczy wariantu: " + v.name + ". Uwzglednij te ceche wariantu w tytule.",
          category_name: categoryName, parameters: paramsObj, account_names: ["wariant"],
        }).then(r => {
          const t = (r.data.titles && (r.data.titles["wariant"] || Object.values(r.data.titles)[0])) || "";
          if (t) setVariantTitle(prev => ({ ...prev, [v.id]: String(t).substring(0, 75) }));
        }).catch(() => {});
        const descP = axios.post(API + "/offers/generate-text", {
          account_id: enabledAccounts[0]?.account_id || "", category_id: categoryId,
          context: context + "\n\nUWAGA: opis dotyczy WYLACZNIE wariantu: " + v.name + ". Jesli kontekst wymienia rozne warianty, opisz TYLKO ten wariant.",
          category_name: categoryName, parameters: paramsObj, generate_title: false, generate_description: true,
        }).then(r => {
          if (r.data.description) setVariantDesc(prev => ({ ...prev, [v.id]: formatHtmlForTextarea(r.data.description) }));
        }).catch(() => {});
        return [titleP, descP];
      }).flat();
      await Promise.all([eanPromise, ...perVariant]);
    } catch {}
    setGeneratingVariantData(false);
  };

  const generateAllTitles = async () => {
    if (!context || !categoryId || enabledAccounts.length === 0) return;
    setGeneratingTitles(true);
    try {
      const paramsObj = getParamsText();
      const accountNames = enabledAccounts.map(c => c.account_name);
      const r = await axios.post(API + "/offers/generate-titles", {
        context, category_name: categoryName, parameters: paramsObj,
        account_names: accountNames,
        account_id: enabledAccounts[0].account_id
      });
      if (r.data.titles) {
        enabledAccounts.forEach((cfg, i) => {
          const t = r.data.titles[cfg.account_name] || r.data.titles[i] || "";
          if (t) updateConfig(cfg.account_id, "title", t);
        });
      }
    } catch {}
    setGeneratingTitles(false);
  };

  const generateOneTitle = async (account_id: string) => {
    if (!context || !categoryId) return;
    setGeneratingTitles(true);
    try {
      const cfg = enabledAccounts.find(c => c.account_id === account_id);
      if (!cfg) return;
      const otherTitles = enabledAccounts.filter(c => c.account_id !== account_id && c.title).map(c => c.title);
      const paramsObj = getParamsText();
      const r = await axios.post(API + "/offers/generate-titles", {
        context, category_name: categoryName, parameters: paramsObj,
        account_names: [cfg.account_name],
        other_titles: otherTitles,
        account_id: account_id
      });
      if (r.data.titles) {
        const t = r.data.titles[cfg.account_name] || r.data.titles[0] || "";
        if (t) updateConfig(account_id, "title", t);
      }
    } catch {}
    setGeneratingTitles(false);
  };

  const generateOneDesc = async (account_id: string) => {
    if (!context || !categoryId) return;
    setGeneratingDesc(true);
    try {
      const cfg = account_id ? enabledAccounts.find(c => c.account_id === account_id) : null;
      const titleForDesc = cfg?.title || enabledAccounts[0]?.title || context;
      const paramsObj = getParamsText();
      const r = await axios.post(API + "/offers/generate-text", {
        account_id: account_id || enabledAccounts[0]?.account_id,
        category_id: categoryId, category_name: categoryName,
        context: context + (titleForDesc ? "\nTytuł: " + titleForDesc : ""),
        parameters: paramsObj,
        generate_title: false, generate_description: true
      });
      if (r.data.description) {
        const formatted = formatHtmlForTextarea(r.data.description);
        if (account_id) updateConfig(account_id, "description", formatted);
        else setDescription(formatted);
      }
    } catch(e) {
      console.error("Blad generowania opisu:", e);
    } finally {
      setGeneratingDesc(false);
    }
  };

  const generateAllDescs = async () => {
    if (!context || !categoryId || enabledAccounts.length === 0) return;
    setGeneratingDesc(true);
    try {
      for (const cfg of enabledAccounts) {
        try {
          const paramsObj = getParamsText();
          const r = await axios.post(API + "/offers/generate-text", {
            account_id: cfg.account_id,
            category_id: categoryId, category_name: categoryName,
            context: context + (cfg.title ? "\nTytuł: " + cfg.title : ""),
            parameters: paramsObj,
            generate_title: false, generate_description: true
          });
          if (r.data.description) updateConfig(cfg.account_id, "description", formatHtmlForTextarea(r.data.description));
        } catch(e) { console.error("Blad opisu dla", cfg.account_name, e); }
      }
    } finally {
      setGeneratingDesc(false);
    }
  };

  // NEW: helper do budowania parametrów oferty (wspólna logika dla single i variant)
  const buildPerAccountParams = (cfg: AccountConfig, baseParams: any[]): any[] => {
    const perAccountParams = [...baseParams];
    const MODEL_IDS = ["237206","234493","243973","249034"];
    const modelParam = allCategoryParams.find((p:any) => MODEL_IDS.includes(p.id));
    const zamiennikiParam = allCategoryParams.find((p:any) => p.id === "215941");
    const oryginalParam = allCategoryParams.find((p:any) => p.id === "227345");
    if (modelParam && cfg.param_model?.trim()) {
      const idx = perAccountParams.findIndex((p:any) => p.id === modelParam.id);
      const np = {id: modelParam.id, values: [cfg.param_model.trim()], describesProduct: true, ambiguousValueId: null, customValuesEnabled: false, customValue: ""};
      if (idx >= 0) perAccountParams[idx] = np; else perAccountParams.push(np);
    }
    if (zamiennikiParam && cfg.param_zamienniki?.trim()) {
      const idx = perAccountParams.findIndex((p:any) => p.id === "215941");
      const np = {id: "215941", values: [cfg.param_zamienniki.trim()], describesProduct: true, ambiguousValueId: null, customValuesEnabled: false, customValue: ""};
      if (idx >= 0) perAccountParams[idx] = np; else perAccountParams.push(np);
    }
    if (oryginalParam && cfg.param_oryginal?.trim()) {
      const idx = perAccountParams.findIndex((p:any) => p.id === "227345");
      const np = {id: "227345", values: [cfg.param_oryginal.trim()], describesProduct: true, ambiguousValueId: null, customValuesEnabled: false, customValue: ""};
      if (idx >= 0) perAccountParams[idx] = np; else perAccountParams.push(np);
    }
    return perAccountParams;
  };

  const publish = async (asDraft = false) => {
    if (enabledAccounts.length === 0) { setPublishError("Zaznacz co najmniej jedno konto"); return; }
    // Tytul: bazowy (per konto/globalny) LUB - w trybie wariantow - tytul per wariant dla kazdego wariantu
    const anyBaseTitle = enabledAccounts.some(c => (c.title || title || "").trim());
    const everyVariantHasTitle = offerMode === "variants" && selectedVariantValues.length > 0
      && selectedVariantValues.every(v => (variantTitle[v.id] || "").trim());
    const titleOk = anyBaseTitle || everyVariantHasTitle;
    if (!categoryId || !titleOk || uploadedImages.filter(i => i.url).length === 0) { setPublishError("Uzupełnij: kategoria, tytuł (krok 3 lub per wariant) i min. 1 zdjęcie"); return; }

    // NEW: walidacja wariantów przed wystawianiem
    if (offerMode === "variants") {
      if (selectedVariantValues.length < 2) { setPublishError("Wpisz co najmniej 2 warianty w Kroku 2."); return; }
    }

    // Parametry wpisywane per konto w kroku 5 (model / nr katalogowy, zamienniki, oryginal):
    // jesli Allegro ich wymaga, kazde zaznaczone konto musi je miec (albo kazdy wariant - nadpisanie per wariant).
    {
      const reqIds = categoryParams.required.map((p: any) => p.id);
      const modelP = allCategoryParams.find((p: any) => ["237206","234493","243973","249034"].includes(p.id));
      const zamP = allCategoryParams.find((p: any) => p.id === "215941");
      const orgP = allCategoryParams.find((p: any) => p.id === "227345");
      const checks: { p: any; field: string }[] = [];
      if (modelP && reqIds.includes(modelP.id)) checks.push({ p: modelP, field: "param_model" });
      if (zamP && reqIds.includes(zamP.id)) checks.push({ p: zamP, field: "param_zamienniki" });
      if (orgP && reqIds.includes(orgP.id)) checks.push({ p: orgP, field: "param_oryginal" });
      const perVariantOk = (pid: string) => offerMode === "variants" && selectedVariantValues.length > 0
        && selectedVariantValues.every(v => String((variantParamOverrides[v.id] || {})[pid] || "").trim() !== "");
      const missingPA: string[] = [];
      for (const c of enabledAccounts) {
        for (const ch of checks) {
          const val = String((c as any)[ch.field] || "").trim();
          if (!val && !perVariantOk(ch.p.id)) missingPA.push(c.account_name + " – " + ch.p.name);
        }
      }
      if (missingPA.length > 0) { setPublishError("Uzupełnij w kroku 5 (Parametry różnicujące): " + missingPA.join(", ")); return; }
    }

    setPublishing(true); setPublishError(""); setPublishResults([]);

    // Buduj bazowe parametry (wspólne dla wszystkich)
    const parametersPayload: any[] = [];
    allCategoryParams.forEach((p: any) => {
      if (!paramValues[p.id]) return;
      const multipleChoices = p.restrictions?.multipleChoices === true;
      const ambiguousId = p.options?.ambiguousValueId || null;
      const customValuesEnabled = p.options?.customValuesEnabled || false;

      // Obsluga parametrow zakresowych (np. Napiecie od-do)
      if (p.restrictions?.range === true) {
        const rv = paramValues[p.id];
        if (rv && (rv.from || rv.to)) {
          const rangeValue: any = {};
          if (rv.from) rangeValue.from = rv.from;
          if (rv.to) rangeValue.to = rv.to;
          parametersPayload.push({
            id: p.id,
            rangeValue,
            describesProduct: p.options?.describesProduct || false,
          });
        }
        return;
      }
      // Obsługa wielu wartości (multipleChoices)
      if (multipleChoices && Array.isArray(paramValues[p.id])) {
        const ids = (paramValues[p.id] as unknown as string[]).filter(Boolean);
        if (ids.length === 0) return;
        parametersPayload.push({
          id: p.id,
          valuesIds: ids,
          describesProduct: p.options?.describesProduct || false,
          ambiguousValueId: null,
          customValuesEnabled: false,
          customValue: "",
        });
        return;
      }

      const isAmbiguousSelected = ambiguousId && paramValues[p.id] === ambiguousId;
      const customValue = paramCustomValues[p.id] || "";
      const d = p.dictionary?.find((d:any) => d.id === paramValues[p.id]);
      let param: any;
      if (isAmbiguousSelected && customValuesEnabled) {
        param = { id: p.id, valuesIds: [paramValues[p.id]], values: customValue ? [customValue] : [] };
      } else if (d) {
        param = { id: p.id, valuesIds: [paramValues[p.id]] };
      } else {
        param = { id: p.id, values: [paramValues[p.id]] };
      }
      param.describesProduct = p.options?.describesProduct || false;
      param.ambiguousValueId = ambiguousId;
      param.customValuesEnabled = customValuesEnabled;
      param.customValue = (isAmbiguousSelected && customValuesEnabled) ? customValue : "";
      if (ambiguousId) {
        const ambiguousEntry = p.dictionary?.find((d:any) => d.id === ambiguousId);
        param.ambiguousValueName = ambiguousEntry?.name || "Inny";
      }
      parametersPayload.push(param);
    });

    const results: any[] = [];
    let offerIndex = 0;

    for (const cfg of enabledAccounts) {
      if (!cfg.price) { results.push({ account: cfg.account_name, status: "error", error: "Brak ceny" }); continue; }

      // Buduj parametry per konto (model, zamienniki, oryginał)
      let perAccountParams = buildPerAccountParams(cfg, parametersPayload);
      // W trybie wariantow EAN jest ustawiany per wariant - usun wspolny parametr EAN
      if (offerMode === "variants") {
        const eanDef = allCategoryParams.find((p: any) => /ean|gtin|kod produktu/i.test(p.name || ""));
        if (eanDef) perAccountParams = perAccountParams.filter((p: any) => p.id !== eanDef.id);
      }

      if (offerMode === "variants" && selectedVariantValues.length > 0) {
        // NEW: Tryb wariantów – tworzenie N ofert per konto, jedna per wartość wariantu
        for (const variantValue of selectedVariantValues) {
          if (offerIndex > 0) {
            await new Promise(resolve => setTimeout(resolve, 10000));
          }
          offerIndex++;

          // Nadpisz parametr wariantu konkretną wartością (tylko w trybie parametru kategorii)
          const variantParams = [...perAccountParams];
          if (variantMode === "param" && variantParamId && !variantValue.id.startsWith("custom_")) {
            const existingVariantParamIdx = variantParams.findIndex((p: any) => p.id === variantParamId);
            const variantParamDef = allCategoryParams.find((p: any) => p.id === variantParamId);
            const newVariantParamEntry = {
              id: variantParamId,
              valuesIds: [variantValue.id],
              describesProduct: variantParamDef?.options?.describesProduct || false,
              ambiguousValueId: null,
              customValuesEnabled: false,
              customValue: "",
            };
            if (existingVariantParamIdx >= 0) {
              variantParams[existingVariantParamIdx] = newVariantParamEntry;
            } else {
              variantParams.push(newVariantParamEntry);
            }
          }
          // W trybie własnych nazw — brak dodatkowego parametru, nazwa wariantu tylko w tytule

          // EAN per wariant: nadpisz parametr EAN wartoscia z variantEan (jesli ustawiona)
          const variantEanVal = (variantEan[variantValue.id] || "").trim();
          if (variantEanVal) {
            const eanParamDef = allCategoryParams.find((p: any) => /ean|gtin|kod produktu/i.test(p.name || ""));
            if (eanParamDef) {
              const eanIdx = variantParams.findIndex((p: any) => p.id === eanParamDef.id);
              const eanEntry: any = { id: eanParamDef.id, values: [variantEanVal], describesProduct: eanParamDef.options?.describesProduct || false };
              if (eanIdx >= 0) variantParams[eanIdx] = eanEntry; else variantParams.push(eanEntry);
            }
          }

          // Nadpisania parametrow per wariant (dowolne parametry wybrane przez sprzedawce)
          const vOverrides = variantParamOverrides[variantValue.id] || {};
          for (const [ovParamId, ovValue] of Object.entries(vOverrides)) {
            const val = String(ovValue || "").trim();
            if (!val) continue;
            const ovDef = allCategoryParams.find((p: any) => p.id === ovParamId);
            if (!ovDef) continue;
            // wartosc slownikowa -> valuesIds; tekstowa -> values
            const dictEntry = ovDef.dictionary?.find((d: any) => d.id === val || d.name === val);
            const ovEntry: any = dictEntry
              ? { id: ovParamId, valuesIds: [dictEntry.id], describesProduct: ovDef.options?.describesProduct || false }
              : { id: ovParamId, values: [val], describesProduct: ovDef.options?.describesProduct || false };
            const ovIdx = variantParams.findIndex((p: any) => p.id === ovParamId);
            if (ovIdx >= 0) variantParams[ovIdx] = ovEntry; else variantParams.push(ovEntry);
          }

          // Zdjęcia dla tego wariantu i tego konta (fallback: per-konto wariantu -> cfg per-konto -> globalne)
          const vi: VariantImageConfig = (variantImages[variantValue.id] && variantImages[variantValue.id][cfg.account_id]) || { main: "", extra: [] };
          // Zdjecia wariantu maja PRIORYTET. Fallback (cfg/pula) tylko gdy wariant nie ma WLASNYCH zdjec dla tego konta.
          const hasVariantImages = !!vi.main || (vi.extra && vi.extra.length > 0);
          const mainUrl = hasVariantImages ? vi.main : (cfg.main_image_url || uploadedImages[0]?.url || "");
          const extraUrls = hasVariantImages ? (vi.extra || []) : (cfg.extra_images || []);
          const orderedImages = (mainUrl
            ? [mainUrl, ...extraUrls.filter((u: string) => u !== mainUrl)]
            : extraUrls).slice(0, 16); // Allegro: max 16 zdjec

          if (orderedImages.length === 0) {
            results.push({ account: cfg.account_name, variant: variantValue.name, status: "error", error: "Brak zdjęć dla wariantu" });
            continue;
          }

          // Tytuł: per wariant (jesli ustawiony) albo bazowy + nazwa wariantu (ucinamy do 75 znaków)
          const baseTitle = (cfg.title || title || "").trim();
          const vTitleOverride = (variantTitle[variantValue.id] || "").trim();
          const variantTitleFinal = (vTitleOverride || (baseTitle + " " + variantValue.name)).trim().substring(0, 75);

          try {
            const r = await axios.post(API + "/offers/create", {
              account_id: cfg.account_id,
              category_id: categoryId,
              name: variantTitleFinal,
              description: (variantDesc[variantValue.id] || (sameDescForAll ? description : cfg.description)) || `<p>${variantTitleFinal}</p>`,
              images: orderedImages,
              sku: (variantSku[variantValue.id] || "").trim() || (cfg.sku ? cfg.sku + "-" + variantValue.name.replace(/\s+/g, "-").toLowerCase() : null),
              responsible_producer_id: cfg.responsible_producer_id || null,
              responsible_person_id: cfg.responsible_person_id || null,
              safety_info_template: cfg.safety_info_template || null,
              price: parseFloat((variantPrice[variantValue.id] || "").trim() || cfg.price),
              stock: parseInt((variantStock[variantValue.id] || "").trim() || cfg.stock) || 1,
              handling_time: cfg.handling_time,
              shipping_rates_id: cfg.shipping_rates_id || null,
              return_policy_id: cfg.return_policy_id || null,
              implied_warranty_id: cfg.implied_warranty_id || null,
              warranty_id: cfg.warranty_id || null,
              invoice: cfg.invoice,
              location_city: cfg.location_city || null,
              location_zip: cfg.location_zip || null,
              location_province: cfg.location_province || null,
              parameters: variantParams,
              product_id: selectedProduct?.id || null,
              publish: !asDraft,
              marketed_before_gpsr: cfg.marketed_before_gpsr,
              publication_duration: cfg.publication_duration || null,
              marketplaces: selectedMarketplaces,
              message_to_seller: messageToSeller,
              republish: republish,
              vat_rates: vatRates,
            });
            results.push({ account: cfg.account_name, variant: variantValue.name, status: r.data.status, offer_id: r.data.offer_id, errors: r.data.errors });
          } catch (e: any) {
            results.push({ account: cfg.account_name, variant: variantValue.name, status: "error", error: e?.response?.data?.detail || "Błąd" });
          }
        }

      } else {
        // Tryb pojedynczej oferty – oryginalna logika bez zmian
        if (offerIndex > 0) {
          await new Promise(resolve => setTimeout(resolve, 10000));
        }
        offerIndex++;

        const mainUrl = cfg.main_image_url || uploadedImages[0]?.url || "";
        const extraUrls = cfg.extra_images || [];
        const orderedImages = mainUrl ? [mainUrl, ...extraUrls.filter((u:string) => u !== mainUrl)] : extraUrls;
        if (orderedImages.length === 0) { results.push({ account: cfg.account_name, status: "error", error: "Brak zdjęć dla konta" }); continue; }

        try {
          const r = await axios.post(API + "/offers/create", {
            account_id: cfg.account_id,
            category_id: categoryId,
            name: cfg.title || title,
            description: (sameDescForAll ? description : cfg.description) || `<p>${cfg.title || title}</p>`,
            images: orderedImages,
            sku: cfg.sku || null,
            responsible_producer_id: cfg.responsible_producer_id || null,
            responsible_person_id: cfg.responsible_person_id || null,
            safety_info_template: cfg.safety_info_template || null,
            price: parseFloat(cfg.price),
            stock: parseInt(cfg.stock) || 1,
            handling_time: cfg.handling_time,
            shipping_rates_id: cfg.shipping_rates_id || null,
            return_policy_id: cfg.return_policy_id || null,
            implied_warranty_id: cfg.implied_warranty_id || null,
            warranty_id: cfg.warranty_id || null,
            invoice: cfg.invoice,
            location_city: cfg.location_city || null,
            location_zip: cfg.location_zip || null,
            location_province: cfg.location_province || null,
            parameters: perAccountParams,
            product_id: selectedProduct?.id || null,
            publish: !asDraft,
            marketed_before_gpsr: cfg.marketed_before_gpsr,
            publication_duration: cfg.publication_duration || null,
            marketplaces: selectedMarketplaces,
            message_to_seller: messageToSeller,
            republish: republish,
            vat_rates: vatRates,
          });
          results.push({ account: cfg.account_name, status: r.data.status, offer_id: r.data.offer_id, errors: r.data.errors });
        } catch (e: any) {
          results.push({ account: cfg.account_name, status: "error", error: e?.response?.data?.detail || "Błąd" });
        }
      }
    }

    setPublishResults(results);
    setPublishing(false);
  };

  // ===== RENDER =====
  return (
    <div style={{ padding: 16, maxWidth: 960, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#6b7280" }}>←</button>
        <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Wystaw nową ofertę</h2>
        {/* NEW: badge trybu */}
        {offerMode === "variants" && (
          <span style={{ fontSize: 11, background: "#f3e8ff", color: "#7c3aed", borderRadius: 20, padding: "2px 10px", fontWeight: 600 }}>
            🎨 Tryb wariantów ({selectedVariantValues.length} war. × {enabledAccounts.length} kont)
          </span>
        )}
      </div>
      <div style={{ display: "flex", gap: 4, marginBottom: 16, flexWrap: "wrap" as const }}>
        {["1. Konta i zdjęcia", "2. Kategoria", "3. Opis", "4. Warunki", "5. Wystawianie"].map((label, i) => (
          <button key={i} onClick={() => goToStep(i+1)} style={s.stepBtn(step === i+1)}>{label}</button>
        ))}
      </div>

      {/* KROK 1 — Konta i zdjecia */}
      {step === 1 && (
        <div>
          {/* Wybor kont */}
          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Wybierz konta do wystawienia *</div>
            {accountConfigs.map(cfg => (
              <div key={cfg.account_id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "1px solid #f3f4f6" }}>
                <input type="checkbox" checked={cfg.enabled} onChange={e => updateConfig(cfg.account_id, "enabled", e.target.checked)} style={{ width: 16, height: 16, cursor: "pointer" }} />
                <span style={{ fontSize: 13, fontWeight: cfg.enabled ? 600 : 400, color: cfg.enabled ? "#111827" : "#6b7280" }}>{cfg.account_name}</span>
                {cfg.enabled && <span style={{ fontSize: 11, color: "#15803d", background: "#f0fdf4", borderRadius: 4, padding: "1px 6px" }}>✓</span>}
              </div>
            ))}
            {enabledAccounts.length === 0 && <div style={{ fontSize: 12, color: "#f59e0b", marginTop: 8 }}>⚠ Zaznacz co najmniej jedno konto</div>}
          </div>

          {/* NEW: Wybor trybu oferty — przed zdjęciami */}
          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Typ oferty *</div>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => { setOfferMode("single"); setVariantParamId(""); setSelectedVariantValueIds([]); setVariantImages({}); setVariantShowPicker({}); }}
                style={{ ...s.btn, background: offerMode === "single" ? "#1d4ed8" : "#f3f4f6", color: offerMode === "single" ? "#fff" : "#374151", border: `2px solid ${offerMode === "single" ? "#1d4ed8" : "#d1d5db"}` }}>
                📦 Pojedyncza oferta
              </button>
              <button
                onClick={() => setOfferMode("variants")}
                style={{ ...s.btn, background: offerMode === "variants" ? "#7c3aed" : "#f3f4f6", color: offerMode === "variants" ? "#fff" : "#374151", border: `2px solid ${offerMode === "variants" ? "#7c3aed" : "#d1d5db"}` }}>
                🎨 Oferta z wariantami
              </button>
            </div>
            {offerMode === "single" && (
              <div style={{ fontSize: 11, color: "#6b7280", marginTop: 8 }}>
                Jedna oferta wystawiona na każdym zaznaczonym koncie. Zdjęcia przypisujesz per konto.
              </div>
            )}
            {offerMode === "variants" && (
              <div style={{ fontSize: 11, color: "#7c3aed", marginTop: 8, background: "#faf5ff", border: "1px solid #e9d5ff", borderRadius: 6, padding: "6px 10px" }}>
                💡 Wgraj <strong>wszystkie zdjęcia produktu</strong> poniżej — w Kroku 2 przypisz je do poszczególnych wariantów (np. inne zdjęcie per kolor).
              </div>
            )}
          </div>

          {/* Baza zdjec */}
          <div style={s.card}
            onDragOver={e => { e.preventDefault(); e.currentTarget.style.background = "#eff6ff"; }}
            onDragLeave={e => { e.currentTarget.style.background = "#fff"; }}
            onDrop={e => { e.preventDefault(); e.currentTarget.style.background = "#fff"; if (e.dataTransfer.files) uploadImages(e.dataTransfer.files); }}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Baza zdjęć</div>
            <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 10 }}>
              {offerMode === "variants"
                ? "Wgraj wszystkie zdjęcia produktu. W Kroku 2 przypisz je do poszczególnych wariantów."
                : "Kliknij zdjęcie aby przypisać jako główne do konta. Przeciągnij pliki tutaj lub kliknij +"}
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" as const, marginBottom: 10, minHeight: 100, alignItems: "flex-start" }}>
              {images.map((img, idx) => (
                <div key={idx} style={{ position: "relative", display: "flex", flexDirection: "column" as const, alignItems: "center", gap: 2 }}>
                  <div style={{ position: "relative", cursor: img.url && img.url !== "ERROR" ? "pointer" : "default" }}
                    onClick={() => {
                      if (!img.url || img.url === "ERROR") return;
                      // W trybie single – przypisz jako główne do pierwszego konta bez głównego
                      if (offerMode === "single") {
                        const firstWithout = enabledAccounts.find(c => !c.main_image_url);
                        if (firstWithout) updateConfig(firstWithout.account_id, "main_image_url", img.url);
                      }
                      // W trybie wariantów – kliknięcie w bazie nie przypisuje (użytkownik robi to w kroku 2)
                    }}>
                    <img src={img.preview} alt="" style={{ width: 80, height: 80, objectFit: "cover" as const, borderRadius: 6, border: img.uploading ? "2px solid #fcd34d" : img.url === "ERROR" ? "2px solid #dc2626" : "2px solid #d1d5db" }} />
                    {img.uploading && <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.4)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 11 }}>↑</div>}
                    {img.url === "ERROR" && <div style={{ position: "absolute", inset: 0, background: "rgba(220,38,38,0.5)", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 11 }}>✗</div>}
                    <div style={{ position: "absolute", top: 2, left: 2, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 9, borderRadius: 3, padding: "1px 4px" }}>{idx+1}</div>
                    {img.url && img.url !== "ERROR" && offerMode === "single" && (
                      <div style={{ position: "absolute", bottom: 2, right: 2, background: "rgba(29,78,216,0.8)", color: "#fff", fontSize: 9, borderRadius: 3, padding: "1px 4px" }}>kliknij</div>
                    )}
                  </div>
                  {/* Przycisk usuń zdjęcie z bazy */}
                  <button onClick={() => removeImage(idx)} style={{ fontSize: 9, padding: "1px 5px", background: "#fee2e2", color: "#dc2626", border: "1px solid #fca5a5", borderRadius: 3, cursor: "pointer" }}>✕</button>
                </div>
              ))}
              <div onClick={() => enabledAccounts.length > 0 ? fileInputRef.current?.click() : alert("Najpierw zaznacz konta")}
                style={{ width: 80, height: 80, border: "2px dashed #d1d5db", borderRadius: 6, display: "flex", flexDirection: "column" as const, alignItems: "center", justifyContent: "center", cursor: enabledAccounts.length > 0 ? "pointer" : "not-allowed", color: "#9ca3af", opacity: enabledAccounts.length > 0 ? 1 : 0.5 }}>
                <div style={{ fontSize: 24 }}>+</div>
                <div style={{ fontSize: 10 }}>Dodaj</div>
              </div>
            </div>
            <input ref={fileInputRef} type="file" multiple accept="image/*" style={{ display: "none" }}
              onChange={e => { if (e.target.files) uploadImages(e.target.files); e.target.value = ""; }} />
            {uploadedImages.length > 0 && enabledAccounts.length > 0 && offerMode === "single" && (
              <div style={{ fontSize: 11, color: "#6b7280", padding: "6px 8px", background: "#f9fafb", borderRadius: 6 }}>
                💡 Kliknij zdjęcie aby przypisać jako główne do kolejnego konta
              </div>
            )}
            {uploadedImages.length > 0 && offerMode === "variants" && (
              <div style={{ fontSize: 11, color: "#7c3aed", padding: "6px 8px", background: "#faf5ff", borderRadius: 6, border: "1px solid #e9d5ff" }}>
                🎨 Tryb wariantów — w Kroku 2 przypisz zdjęcia do poszczególnych wariantów
              </div>
            )}
          </div>

          {/* Galeria per konto – tylko w trybie pojedynczej oferty */}
          {offerMode === "single" && enabledAccounts.length > 0 && uploadedImages.length > 0 && (
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Zdjęcia per konto</div>
              {enabledAccounts.map(cfg => (
                <div key={cfg.account_id} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#1d4ed8", marginBottom: 8 }}>📦 {cfg.account_name}</div>
                  <div style={{ display: "flex", gap: 12, alignItems: "flex-start", flexWrap: "wrap" as const }}>
                    <div style={{ minWidth: 120 }}>
                      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 500 }}>Główne:</div>
                      {cfg.main_image_url ? (
                        <div style={{ position: "relative", width: 80, height: 80 }}>
                          <img src={images.find(i=>i.url===cfg.main_image_url)?.preview || cfg.main_image_url} alt="" style={{ width: 80, height: 80, objectFit: "cover" as const, borderRadius: 6, border: "2px solid #1d4ed8" }} />
                          <button onClick={() => updateConfig(cfg.account_id, "main_image_url", "")}
                            style={{ position: "absolute", top: -4, right: -4, background: "#dc2626", color: "#fff", border: "none", borderRadius: "50%", width: 18, height: 18, fontSize: 10, cursor: "pointer", lineHeight: "18px", padding: 0 }}>✕</button>
                          <div style={{ position: "absolute", bottom: 2, left: 2, background: "#1d4ed8", color: "#fff", fontSize: 8, borderRadius: 3, padding: "1px 3px" }}>GŁÓWNE</div>
                        </div>
                      ) : (
                        <div style={{ width: 80, height: 80, border: "2px dashed #fcd34d", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#92400e", background: "#fffbeb", textAlign: "center" as const, padding: 4 }}>
                          Kliknij zdjęcie z bazy
                        </div>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 500 }}>Dodatkowe:</div>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" as const, alignItems: "center" }}>
                        {(cfg.extra_images || []).map((url: string, eidx: number) => (
                          <div key={eidx}
                            draggable
                            onDragStart={e => { e.dataTransfer.setData("eidx", String(eidx)); e.dataTransfer.setData("account_id", cfg.account_id); }}
                            onDragOver={e => e.preventDefault()}
                            onDrop={e => {
                              e.preventDefault();
                              const fromIdx = parseInt(e.dataTransfer.getData("eidx"));
                              const fromAccount = e.dataTransfer.getData("account_id");
                              if (fromAccount !== cfg.account_id || fromIdx === eidx) return;
                              const arr = [...(cfg.extra_images||[])];
                              const [moved] = arr.splice(fromIdx, 1);
                              arr.splice(eidx, 0, moved);
                              updateConfig(cfg.account_id, "extra_images", arr);
                            }}
                            style={{ display: "flex", flexDirection: "column" as const, alignItems: "center", gap: 2, cursor: "grab" }}>
                            <div style={{ position: "relative", width: 60, height: 60 }}>
                              <img src={images.find(i=>i.url===url)?.preview || url} alt="" style={{ width: 60, height: 60, objectFit: "cover" as const, borderRadius: 5, border: "1px solid #d1d5db" }} />
                              <button onClick={() => updateConfig(cfg.account_id, "extra_images", (cfg.extra_images||[]).filter((_:string,j:number)=>j!==eidx))}
                                style={{ position: "absolute", top: -4, right: -4, background: "#dc2626", color: "#fff", border: "none", borderRadius: "50%", width: 16, height: 16, fontSize: 9, cursor: "pointer", lineHeight: "16px", padding: 0 }}>✕</button>
                            </div>
                            <div style={{ display: "flex", gap: 2 }}>
                              <button disabled={eidx === 0} onClick={() => {
                                const arr = [...(cfg.extra_images||[])];
                                [arr[eidx-1], arr[eidx]] = [arr[eidx], arr[eidx-1]];
                                updateConfig(cfg.account_id, "extra_images", arr);
                              }} style={{ ...s.btn, padding: "1px 4px", fontSize: 9, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", opacity: eidx===0?0.3:1 }}>←</button>
                              <button disabled={eidx === (cfg.extra_images||[]).length-1} onClick={() => {
                                const arr = [...(cfg.extra_images||[])];
                                [arr[eidx], arr[eidx+1]] = [arr[eidx+1], arr[eidx]];
                                updateConfig(cfg.account_id, "extra_images", arr);
                              }} style={{ ...s.btn, padding: "1px 4px", fontSize: 9, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", opacity: eidx===(cfg.extra_images||[]).length-1?0.3:1 }}>→</button>
                            </div>
                          </div>
                        ))}
                        <div style={{ position: "relative" }}>
                          <button onClick={() => updateConfig(cfg.account_id, "_showPicker", !cfg._showPicker)}
                            style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", padding: "4px 8px", fontSize: 11 }}>+ Dodaj</button>
                          {cfg._showPicker && (
                            <div style={{ position: "absolute", top: 30, left: 0, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: 8, zIndex: 100, display: "flex", gap: 4, flexWrap: "wrap" as const, maxWidth: 300, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                              {uploadedImages.filter(img => img.url !== cfg.main_image_url && !(cfg.extra_images||[]).includes(img.url)).map((img, pidx) => (
                                <img key={pidx} src={img.preview} alt="" onClick={() => {
                                  updateConfig(cfg.account_id, "extra_images", [...(cfg.extra_images||[]), img.url]);
                                  updateConfig(cfg.account_id, "_showPicker", false);
                                }} style={{ width: 50, height: 50, objectFit: "cover" as const, borderRadius: 4, cursor: "pointer", border: "1px solid #d1d5db" }} />
                              ))}
                              <button onClick={() => updateConfig(cfg.account_id, "_showPicker", false)}
                                style={{ ...s.btn, background: "#f3f4f6", color: "#6b7280", fontSize: 10, padding: "2px 6px" }}>Zamknij</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <button onClick={() => setStep(2)} disabled={enabledAccounts.length === 0 || uploadedImages.length === 0}
            style={{ ...s.btn, background: "#1d4ed8", color: "#fff", opacity: enabledAccounts.length === 0 || uploadedImages.length === 0 ? 0.5 : 1 }}>Dalej →</button>
        </div>
      )}

      {/* KROK 2 — Kategoria */}
      {step === 2 && (
        <div>
          {templates.length > 0 && (
            <div style={s.card}>
              <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Szablon kategorii (opcjonalnie)</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" as const }}>
                {templates.map(t => (
                  <button key={t.id} onClick={() => { applyTemplate(t); if (t.category_id) selectCategory(t.category_id, t.category_name); }}
                    style={{ ...s.btn, background: selectedTemplate?.id === t.id ? "#1d4ed8" : "#f3f4f6", color: selectedTemplate?.id === t.id ? "#fff" : "#374151", border: "1px solid #d1d5db" }}>
                    {t.name}
                  </button>
                ))}
                {selectedTemplate && <button onClick={() => setSelectedTemplate(null)} style={{ ...s.btn, background: "#fee2e2", color: "#dc2626", border: "1px solid #fca5a5" }}>✕</button>}
              </div>
            </div>
          )}

          {categoryId ? (
            <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "10px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                {categoryPath && <div style={{ fontSize: 10, color: "#6b7280" }}>{categoryPath}</div>}
                <div style={{ fontSize: 13, fontWeight: 600, color: "#15803d" }}>✓ {categoryName}</div>
              </div>
              <button onClick={() => {
                setCategoryId(""); setCategoryName(""); setCategoryParams({required:[],optional:[]});
                // NEW: reset wariantów przy zmianie kategorii
                setVariantParamId(""); setSelectedVariantValueIds([]); setVariantImages({}); setVariantShowPicker({});
              }} style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280" }}>✕</button>
            </div>
          ) : (
            <div style={s.card}>
              <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                <button onClick={() => { setCatMode("mine"); loadMineCategories(); }} style={{ ...s.btn, background: catMode==="mine"?"#1d4ed8":"#f3f4f6", color: catMode==="mine"?"#fff":"#374151", border: "1px solid #d1d5db" }}>Z moich ofert</button>
                <button onClick={() => { setCatMode("search"); setSearchResults([]); setSearchPhrase(""); }} style={{ ...s.btn, background: catMode==="search"?"#1d4ed8":"#f3f4f6", color: catMode==="search"?"#fff":"#374151", border: "1px solid #d1d5db" }}>Szukaj</button>
              </div>
              {catMode === "mine" && mineCategories.map(c => (
                <div key={c.id} onClick={() => selectCategory(c.id, c.name)} style={{ padding: "8px 12px", marginBottom: 4, border: "1px solid #e5e7eb", borderRadius: 6, cursor: "pointer", fontSize: 12, display: "flex", justifyContent: "space-between" }}>
                  <span>{c.name}</span><span style={{ color: "#9ca3af" }}>{c.count} ofert</span>
                </div>
              ))}
              {catMode === "search" && (
                <div>
                  <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                    <input style={{ ...s.input, flex: 1 }} value={searchPhrase} onChange={e => { setSearchPhrase(e.target.value); searchLocalCats(e.target.value); }} placeholder="Szukaj kategorii..." />
                    <button onClick={() => { setBreadcrumb([]); loadChildren(""); }} style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" }}>Drzewo</button>
                  </div>
                  {searchPhrase.length >= 2 && searchResults.map(c => (
                    <div key={c.id} onClick={() => c.leaf ? selectCategory(c.id, c.name, c.path) : (() => { setBreadcrumb(prev=>[...prev,{id:c.id,name:c.name}]); loadChildren(c.id); })()}
                      style={{ padding: "8px 12px", marginBottom: 4, border: "1px solid #e5e7eb", borderRadius: 6, cursor: "pointer", fontSize: 12, background: c.leaf?"#f0fdf4":"#fff" }}>
                      {c.path && <div style={{ fontSize: 10, color: "#9ca3af" }}>{c.path}</div>}
                      <div style={{ display: "flex", justifyContent: "space-between" }}><span>{c.name}</span><span style={{ color: c.leaf?"#15803d":"#6b7280" }}>{c.leaf?"✓":">"}</span></div>
                    </div>
                  ))}
                  {searchPhrase.length < 2 && browseResults.length > 0 && (
                    <div>
                      <div style={{ display: "flex", gap: 4, marginBottom: 8, flexWrap: "wrap" as const }}>
                        <span onClick={() => { setBreadcrumb([]); loadChildren(""); }} style={{ fontSize: 11, color: "#1d4ed8", cursor: "pointer" }}>Allegro</span>
                        {breadcrumb.map((b,i) => (
                          <span key={b.id}><span style={{ color: "#9ca3af", margin: "0 4px" }}>›</span>
                            <span onClick={() => { setBreadcrumb(prev=>prev.slice(0,i+1)); loadChildren(b.id); }} style={{ fontSize: 11, color: "#1d4ed8", cursor: "pointer" }}>{b.name}</span>
                          </span>
                        ))}
                      </div>
                      {browseResults.map(c => (
                        <div key={c.id} onClick={() => c.leaf ? selectCategory(c.id, c.name) : (() => { setBreadcrumb(prev=>[...prev,{id:c.id,name:c.name}]); loadChildren(c.id); })()}
                          style={{ padding: "8px 12px", marginBottom: 4, border: "1px solid #e5e7eb", borderRadius: 6, cursor: "pointer", fontSize: 12, background: c.leaf?"#f0fdf4":"#fff" }}>
                          <div style={{ display: "flex", justifyContent: "space-between" }}><span>{c.name}</span><span style={{ color: c.leaf?"#15803d":"#6b7280" }}>{c.leaf?"✓":">"}</span></div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Konfiguracja wariantów — pojawia się gdy tryb wariantów (wybrany w Kroku 1) + kategoria wybrana */}
          {categoryId && offerMode === "variants" && (
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: "#7c3aed" }}>🎨 Konfiguracja wariantów</div>
              <div style={{ background: "#faf5ff", border: "1px solid #e9d5ff", borderRadius: 6, padding: "8px 12px", marginBottom: 12, fontSize: 11, color: "#7c3aed" }}>
                System utworzy <strong>osobną ofertę dla każdego wariantu</strong> na każdym koncie.
                {enabledAccounts.length > 0 && selectedVariantValues.length > 0 && (
                  <span> Łącznie: <strong>{selectedVariantValues.length} × {enabledAccounts.length} = {selectedVariantValues.length * enabledAccounts.length} ofert</strong>.</span>
                )}
              </div>

              {/* Wybór trybu wariantów */}
              <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                <button
                  onClick={() => { setVariantMode("custom"); setVariantParamId(""); setSelectedVariantValueIds([]); setVariantImages({}); setVariantShowPicker({}); }}
                  style={{ ...s.btn, background: variantMode === "custom" ? "#7c3aed" : "#f3f4f6", color: variantMode === "custom" ? "#fff" : "#374151", border: `2px solid ${variantMode === "custom" ? "#7c3aed" : "#d1d5db"}` }}>
                  ✏️ Własne nazwy
                </button>
                {allowedVariantParams.length > 0 && (
                  <button
                    onClick={() => { setVariantMode("param"); setCustomVariantNames(["", ""]); setVariantImages({}); setVariantShowPicker({}); }}
                    style={{ ...s.btn, background: variantMode === "param" ? "#7c3aed" : "#f3f4f6", color: variantMode === "param" ? "#fff" : "#374151", border: `2px solid ${variantMode === "param" ? "#7c3aed" : "#d1d5db"}` }}>
                    📋 Parametr kategorii
                  </button>
                )}
              </div>

              {/* Tryb własnych nazw */}
              {variantMode === "custom" && (
                <div>
                  <label style={s.label}>Nazwy wariantów * <span style={{ fontWeight: 400, color: "#9ca3af" }}>(min. 2, np. Czerwony, Niebieski, Zielony)</span></label>
                  {customVariantNames.map((name, idx) => (
                    <div key={idx} style={{ display: "flex", gap: 6, marginBottom: 6, alignItems: "center" }}>
                      <input
                        style={{ ...s.input, flex: 1 }}
                        value={name}
                        onChange={e => {
                          const newNames = [...customVariantNames];
                          newNames[idx] = e.target.value;
                          setCustomVariantNames(newNames);
                        }}
                        placeholder={`Wariant ${idx + 1}, np. Czerwony`}
                      />
                      {customVariantNames.length > 2 && (
                        <button onClick={() => {
                          const newNames = customVariantNames.filter((_, i) => i !== idx);
                          setCustomVariantNames(newNames);
                          setVariantImages({});
                          setVariantShowPicker({});
                        }} style={{ ...s.btn, background: "#fee2e2", color: "#dc2626", border: "1px solid #fca5a5", padding: "4px 10px" }}>✕</button>
                      )}
                    </div>
                  ))}
                  <button onClick={() => setCustomVariantNames(prev => [...prev, ""])}
                    style={{ ...s.btn, background: "#f3e8ff", color: "#7c3aed", border: "1px solid #d8b4fe", fontSize: 11, marginTop: 4 }}>
                    + Dodaj wariant
                  </button>
                  {selectedVariantValuesCustom.length > 0 && (
                    <div style={{ fontSize: 11, color: "#7c3aed", fontWeight: 500, marginTop: 8 }}>
                      Wariantów: {selectedVariantValuesCustom.length}
                      {enabledAccounts.length > 0 && ` → ${selectedVariantValuesCustom.length * enabledAccounts.length} ofert łącznie`}
                    </div>
                  )}
                  {customVariantNames.filter(n => n.trim()).length === 1 && (
                    <div style={{ fontSize: 11, color: "#f59e0b", marginTop: 4 }}>⚠ Wpisz co najmniej 2 nazwy wariantów</div>
                  )}
                </div>
              )}

              {/* Tryb parametru kategorii */}
              {variantMode === "param" && (
                <div>
                  <div style={{ marginBottom: 12 }}>
                    <label style={s.label}>Parametr wariantów * <span style={{ fontWeight: 400, color: "#9ca3af" }}>(dozwolone przez Allegro dla tej kategorii)</span></label>
                    <select style={s.input} value={variantParamId} onChange={e => {
                      setVariantParamId(e.target.value);
                      setSelectedVariantValueIds([]);
                      setVariantImages({});
                      setVariantShowPicker({});
                    }}>
                      <option value="">-- wybierz parametr --</option>
                      {allowedVariantParams.map((p: any) => (
                        <option key={p.id} value={p.id}>{p.name} ({p.dictionary.length} wartości)</option>
                      ))}
                    </select>
                  </div>

                  {variantParam && (
                    <div>
                      <label style={s.label}>Wartości wariantów * <span style={{ fontWeight: 400, color: "#9ca3af" }}>(zaznacz te, które chcesz wystawić — min. 2)</span></label>
                      <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 6, marginBottom: 8 }}>
                        {variantParam.dictionary.map((d: any) => {
                          const isSelected = selectedVariantValueIds.includes(d.id);
                          return (
                            <label key={d.id} style={{
                              display: "flex", alignItems: "center", gap: 4, cursor: "pointer",
                              padding: "5px 12px", borderRadius: 20,
                              border: `1px solid ${isSelected ? "#7c3aed" : "#d1d5db"}`,
                              background: isSelected ? "#f3e8ff" : "#fff",
                              color: isSelected ? "#7c3aed" : "#374151",
                              fontWeight: isSelected ? 600 : 400, fontSize: 12,
                              userSelect: "none" as const,
                            }}>
                              <input type="checkbox" checked={isSelected} style={{ display: "none" }} onChange={e => {
                                setSelectedVariantValueIds(prev =>
                                  e.target.checked ? [...prev, d.id] : prev.filter((x: string) => x !== d.id)
                                );
                                if (!e.target.checked) {
                                  setVariantImages(prev => { const n = {...prev}; delete n[d.id]; return n; });
                                  setVariantShowPicker(prev => { const n = {...prev}; delete n[d.id]; return n; });
                                }
                              }} />
                              {isSelected ? "✓ " : ""}{d.name}
                            </label>
                          );
                        })}
                      </div>
                      {selectedVariantValueIds.length > 0 && (
                        <div style={{ fontSize: 11, color: "#7c3aed", fontWeight: 500 }}>
                          Zaznaczono: {selectedVariantValueIds.length} wariantów
                          {enabledAccounts.length > 0 && ` → ${selectedVariantValueIds.length * enabledAccounts.length} ofert łącznie`}
                        </div>
                      )}
                      {selectedVariantValueIds.length === 1 && (
                        <div style={{ fontSize: 11, color: "#f59e0b", marginTop: 4 }}>⚠ Zaznacz co najmniej 2 wartości</div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Zdjecia per wariant — baza + aktywny wariant */}
          {categoryId && offerMode === "variants" && selectedVariantValues.length > 0 && uploadedImages.length > 0 && (
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Zdjęcia per wariant</div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 12 }}>
                Kliknij zakładkę wariantu, potem klikaj zdjęcia z bazy — pierwsze kliknięte staje się głównym.
              </div>

              {/* Zakładki wariantów */}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" as const, marginBottom: 12 }}>
                {selectedVariantValues.map(variant => {
                  const perAccVar = variantImages[variant.id] || {};
                  const imgCount = Object.values(perAccVar).filter((v: any) => v && (v.main || (v.extra && v.extra.length > 0))).length;
                  const isActive = variantShowPicker[variant.id] === true || (Object.keys(variantShowPicker).length === 0 && selectedVariantValues[0]?.id === variant.id);
                  return (
                    <button key={variant.id}
                      onClick={() => {
                        const newPicker: Record<string, boolean> = {};
                        newPicker[variant.id] = true;
                        setVariantShowPicker(newPicker);
                      }}
                      style={{
                        ...s.btn,
                        background: isActive ? "#7c3aed" : "#f3f4f6",
                        color: isActive ? "#fff" : "#374151",
                        border: `2px solid ${isActive ? "#7c3aed" : "#d1d5db"}`,
                        display: "flex", alignItems: "center", gap: 6,
                      }}>
                      🎨 {variant.name}
                      <span style={{ fontSize: 10, background: isActive ? "rgba(255,255,255,0.3)" : "#e5e7eb", borderRadius: 10, padding: "1px 6px" }}>
                        {imgCount} kont
                      </span>
                    </button>
                  );
                })}
              </div>

              {/* Zdjęcia per konto dla aktywnego wariantu */}
              {(() => {
                const activeVariantId = Object.keys(variantShowPicker).find(k => variantShowPicker[k]) || selectedVariantValues[0]?.id || "";
                const activeVariant = selectedVariantValues.find(v => v.id === activeVariantId);
                if (!activeVariant) return null;
                return (
                  <div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, flexWrap: "wrap" as const, gap: 8 }}>
                      <div style={{ fontSize: 12, color: "#7c3aed", fontWeight: 600 }}>
                        Zdjęcia per konto dla wariantu: <strong>{activeVariant.name}</strong>
                        <span style={{ fontWeight: 400, color: "#9ca3af", marginLeft: 6 }}>(główne + dodatkowe, ustaw kolejność strzałkami lub przeciągnij)</span>
                      </div>
                      {enabledAccounts.length > 1 && (
                        <button onClick={() => copyVariantImagesToAll(activeVariantId, enabledAccounts[0].account_id)}
                          style={{ ...s.btn, background: "#eef2ff", color: "#4338ca", border: "1px solid #c7d2fe", fontSize: 11 }}>
                          📋 Kopiuj z „{enabledAccounts[0].account_name}" do wszystkich kont
                        </button>
                      )}
                    </div>
                    {enabledAccounts.map(cfg => {
                      const vi = (variantImages[activeVariantId] && variantImages[activeVariantId][cfg.account_id]) || { main: "", extra: [] };
                      return (
                        <div key={cfg.account_id} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: "#7c3aed", marginBottom: 8 }}>📦 {cfg.account_name}</div>
                          <div style={{ display: "flex", gap: 12, alignItems: "flex-start", flexWrap: "wrap" as const }}>
                            <div style={{ minWidth: 120 }}>
                              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 500 }}>Główne:</div>
                              {vi.main ? (
                                <div style={{ position: "relative", width: 80, height: 80 }}>
                                  <img src={images.find(i=>i.url===vi.main)?.preview || vi.main} alt="" style={{ width: 80, height: 80, objectFit: "cover" as const, borderRadius: 6, border: "2px solid #7c3aed" }} />
                                  <button onClick={() => updateVariantImage(activeVariantId, cfg.account_id, "main", "")}
                                    style={{ position: "absolute", top: -4, right: -4, background: "#dc2626", color: "#fff", border: "none", borderRadius: "50%", width: 18, height: 18, fontSize: 10, cursor: "pointer", lineHeight: "18px", padding: 0 }}>✕</button>
                                  <div style={{ position: "absolute", bottom: 2, left: 2, background: "#7c3aed", color: "#fff", fontSize: 8, borderRadius: 3, padding: "1px 3px" }}>GŁÓWNE</div>
                                </div>
                              ) : (
                                <div style={{ width: 80, height: 80, border: "2px dashed #fcd34d", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#92400e", background: "#fffbeb", textAlign: "center" as const, padding: 4 }}>
                                  Kliknij „+ Dodaj"
                                </div>
                              )}
                            </div>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 500 }}>Dodatkowe:</div>
                              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" as const, alignItems: "center" }}>
                                {(vi.extra || []).map((url: string, eidx: number) => (
                                  <div key={eidx}
                                    draggable
                                    onDragStart={e => { e.dataTransfer.setData("eidx", String(eidx)); e.dataTransfer.setData("account_id", cfg.account_id); }}
                                    onDragOver={e => e.preventDefault()}
                                    onDrop={e => {
                                      e.preventDefault();
                                      const fromIdx = parseInt(e.dataTransfer.getData("eidx"));
                                      const fromAccount = e.dataTransfer.getData("account_id");
                                      if (fromAccount !== cfg.account_id || fromIdx === eidx) return;
                                      const arr = [...(vi.extra||[])];
                                      const [moved] = arr.splice(fromIdx, 1);
                                      arr.splice(eidx, 0, moved);
                                      updateVariantImage(activeVariantId, cfg.account_id, "extra", arr);
                                    }}
                                    style={{ display: "flex", flexDirection: "column" as const, alignItems: "center", gap: 2, cursor: "grab" }}>
                                    <div style={{ position: "relative", width: 60, height: 60 }}>
                                      <img src={images.find(i=>i.url===url)?.preview || url} alt="" style={{ width: 60, height: 60, objectFit: "cover" as const, borderRadius: 5, border: "1px solid #d1d5db" }} />
                                      <button onClick={() => updateVariantImage(activeVariantId, cfg.account_id, "extra", (vi.extra||[]).filter((_:string,j:number)=>j!==eidx))}
                                        style={{ position: "absolute", top: -4, right: -4, background: "#dc2626", color: "#fff", border: "none", borderRadius: "50%", width: 16, height: 16, fontSize: 9, cursor: "pointer", lineHeight: "16px", padding: 0 }}>✕</button>
                                    </div>
                                    <div style={{ display: "flex", gap: 2 }}>
                                      <button disabled={eidx === 0} onClick={() => {
                                        const arr = [...(vi.extra||[])];
                                        [arr[eidx-1], arr[eidx]] = [arr[eidx], arr[eidx-1]];
                                        updateVariantImage(activeVariantId, cfg.account_id, "extra", arr);
                                      }} style={{ ...s.btn, padding: "1px 4px", fontSize: 9, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", opacity: eidx===0?0.3:1 }}>←</button>
                                      <button disabled={eidx === (vi.extra||[]).length-1} onClick={() => {
                                        const arr = [...(vi.extra||[])];
                                        [arr[eidx], arr[eidx+1]] = [arr[eidx+1], arr[eidx]];
                                        updateVariantImage(activeVariantId, cfg.account_id, "extra", arr);
                                      }} style={{ ...s.btn, padding: "1px 4px", fontSize: 9, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", opacity: eidx===(vi.extra||[]).length-1?0.3:1 }}>→</button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              {/* Baza zdjęć — widoczna galeria wszystkich zdjęć, klik przypisuje do tego konta */}
                              <div style={{ marginTop: 8 }}>
                                <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 4 }}>Kliknij zdjęcie aby dodać do konta „{cfg.account_name}" (pierwsze = główne, kolejne = dodatkowe):</div>
                                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" as const, padding: 8, background: "#faf5ff", borderRadius: 6, border: "1px solid #e9d5ff" }}>
                                  {uploadedImages.map((img, pidx) => {
                                    const isMain = img.url === vi.main;
                                    const isExtra = (vi.extra || []).includes(img.url);
                                    const isAssigned = isMain || isExtra;
                                    return (
                                      <div key={pidx} style={{ position: "relative", cursor: isAssigned ? "default" : "pointer" }}
                                        onClick={() => {
                                          if (isAssigned) return;
                                          if (!vi.main) updateVariantImage(activeVariantId, cfg.account_id, "main", img.url);
                                          else updateVariantImage(activeVariantId, cfg.account_id, "extra", [...(vi.extra||[]), img.url]);
                                        }}>
                                        <img src={img.preview} alt="" style={{ width: 56, height: 56, objectFit: "cover" as const, borderRadius: 5, border: isMain ? "3px solid #7c3aed" : isExtra ? "3px solid #a78bfa" : "2px solid #d1d5db", opacity: isAssigned ? 0.45 : 1 }} />
                                        <div style={{ position: "absolute", top: 1, left: 1, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 8, borderRadius: 3, padding: "0px 3px" }}>{pidx + 1}</div>
                                        {isMain && <div style={{ position: "absolute", bottom: 1, left: 1, background: "#7c3aed", color: "#fff", fontSize: 7, borderRadius: 2, padding: "0px 2px" }}>GŁ</div>}
                                        {isExtra && <div style={{ position: "absolute", bottom: 1, left: 1, background: "#a78bfa", color: "#fff", fontSize: 7, borderRadius: 2, padding: "0px 2px" }}>+</div>}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>
          )}

          {categoryId && (
            <div style={s.card}>
              <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Powiąż z produktem Allegro (opcjonalnie)</div>
              <input style={s.input} value={productSearch} onChange={e => { setProductSearch(e.target.value); searchProducts(e.target.value); }} placeholder="Szukaj po EAN lub nazwie..." />
              {selectedProduct && (
                <div style={{ marginTop: 8, padding: "8px 12px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12 }}>
                  <span style={{ fontWeight: 600, color: "#15803d" }}>✓ {selectedProduct.name}</span>
                  <button onClick={() => setSelectedProduct(null)} style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280" }}>✕</button>
                </div>
              )}
              {productResults.length > 0 && !selectedProduct && productResults.map(p => (
                <div key={p.id} onClick={() => { setSelectedProduct(p); setProductResults([]); }}
                  style={{ padding: "6px 10px", marginBottom: 3, border: "1px solid #e5e7eb", borderRadius: 6, cursor: "pointer", fontSize: 12, marginTop: 4 }}>
                  {p.name}
                </div>
              ))}
            </div>
          )}

          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => setStep(1)} style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" }}>← Wstecz</button>
            <button onClick={() => goToStep(3)} disabled={!categoryId} style={{ ...s.btn, background: "#1d4ed8", color: "#fff", opacity: !categoryId?0.5:1 }}>Dalej →</button>
          </div>
        </div>
      )}

      {/* KROK 3 — Kontekst, parametry, tytul, opis */}
      {step === 3 && (
        <div>
          {/* Kontekst */}
          <div style={s.card}>
            <label style={s.label}>Kontekst produktu *</label>
            <textarea value={context} onChange={e => setContext(e.target.value)} rows={4}
              placeholder="Wpisz wszystko co wiesz o produkcie, np: BMW E39, żarówka H4, 12V, 6000K, canbus, 30W, EAN: 5901234123457&#10;AI wygeneruje tytuły, opisy i uzupełni parametry na podstawie tego tekstu."
              style={{ ...s.input, resize: "vertical" as const, fontFamily: "system-ui" }} />
          </div>

          {/* Parametry */}
          {(categoryParams.required.length > 0 || categoryParams.optional.length > 0) && (
            <div style={s.card}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>Parametry: {categoryName}</div>
                <button onClick={() => generateParamsFromContext()} disabled={generatingAI || !context}
                  style={{ ...s.btn, background: generatingAI ? "#f3f4f6" : "#7c3aed", color: generatingAI ? "#374151" : "#fff", fontSize: 11 }}>
                  {generatingAI ? "⏳..." : "✦ Uzupełnij z kontekstu"}
                </button>
              </div>
              {categoryParams.required.length > 0 && (
                <div style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#dc2626", marginBottom: 8 }}>Wymagane *</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    {categoryParams.required.filter((p:any) => !PER_ACCOUNT_PARAM_IDS.includes(p.id)).map((p: any) => {
                      const multipleChoices = p.restrictions?.multipleChoices === true;
                      const selectedIds: string[] = multipleChoices
                        ? (Array.isArray(paramValues[p.id]) ? paramValues[p.id] as unknown as string[] : paramValues[p.id] ? [paramValues[p.id]] : [])
                        : [];
                      return (
                        <div key={p.id}>
                          <label style={s.label}>{p.name}{p.unit ? ` (${p.unit})` : ""} *</label>
                          {p.type === "dictionary" && p.dictionary?.length > 0 ? (
                            <div>
                              {multipleChoices ? (
                                <div style={{ border: "1px solid #d1d5db", borderRadius: 6, padding: "6px 8px", maxHeight: 160, overflowY: "auto" as const, background: "#fff" }}>
                                  {p.dictionary
                                    .filter((d:any) => !(d.id === p.options?.ambiguousValueId && p.options?.describesProduct && !p.options?.customValuesEnabled))
                                    .map((d:any) => {
                                      const checked = selectedIds.includes(d.id);
                                      return (
                                        <label key={d.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "3px 0", cursor: "pointer", fontSize: 12 }}>
                                          <input type="checkbox" checked={checked} onChange={e => {
                                            const newIds = e.target.checked
                                              ? [...selectedIds, d.id]
                                              : selectedIds.filter((x:string) => x !== d.id);
                                            setParamValues(pv => ({...pv, [p.id]: newIds as unknown as string}));
                                          }} />
                                          {d.name}
                                        </label>
                                      );
                                    })}
                                </div>
                              ) : (
                                <select style={s.input} value={paramValues[p.id]||""} onChange={e => setParamValues(pv=>({...pv,[p.id]:e.target.value}))}>
                                  <option value="">-- wybierz --</option>
                                  {p.dictionary
                                    .filter((d:any) => !(d.id === p.options?.ambiguousValueId && p.options?.describesProduct && !p.options?.customValuesEnabled))
                                    .map((d:any) => <option key={d.id} value={d.id}>{d.name}</option>)}
                                </select>
                              )}
                              {!multipleChoices && p.options?.ambiguousValueId && paramValues[p.id] === p.options.ambiguousValueId && p.options?.customValuesEnabled && (
                                <input style={{...s.input, marginTop: 4, borderColor: "#f59e0b"}} value={paramCustomValues[p.id]||""} onChange={e => setParamCustomValues(pv=>({...pv,[p.id]:e.target.value}))} placeholder={`Podaj własną wartość dla "${p.name}"...`} />
                              )}
                              {(p.name.toLowerCase().includes('ilo') || p.name.toLowerCase().includes('sztuk')) && <div style={{ fontSize: 10, color: "#f59e0b", marginTop: 2 }}>⚠ Ustaw ilość ręcznie</div>}
                            </div>
                          ) : p.restrictions?.range === true ? (
                            <div style={{display:"flex",gap:6,alignItems:"center"}}>
                              <input style={s.input} type="number" value={paramValues[p.id]?.from||""} placeholder={`od${p.restrictions?.min!=null?` (min ${p.restrictions.min})`:""}`}
                                onChange={e => setParamValues(pv=>({...pv,[p.id]:{...(pv[p.id]||{}),from:e.target.value}}))} />
                              <span style={{fontSize:12,color:"#6b7280"}}>–</span>
                              <input style={s.input} type="number" value={paramValues[p.id]?.to||""} placeholder={`do${p.restrictions?.max!=null?` (max ${p.restrictions.max})`:""}`}
                                onChange={e => setParamValues(pv=>({...pv,[p.id]:{...(pv[p.id]||{}),to:e.target.value}}))} />
                            </div>
                          ) : <input style={s.input} value={paramValues[p.id]||""} onChange={e => setParamValues(pv=>({...pv,[p.id]:e.target.value}))} placeholder="Wpisz wartość" />}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {categoryParams.optional.length > 0 && (
                <div>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 8 }}>Opcjonalne</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    {categoryParams.optional.filter((p:any) => !PER_ACCOUNT_PARAM_IDS.includes(p.id)).map((p: any) => {
                      const multipleChoices = p.restrictions?.multipleChoices === true;
                      const selectedIds: string[] = multipleChoices
                        ? (Array.isArray(paramValues[p.id]) ? paramValues[p.id] as unknown as string[] : paramValues[p.id] ? [paramValues[p.id]] : [])
                        : [];
                      return (
                        <div key={p.id}>
                          <label style={s.label}>{p.name}{p.unit ? ` (${p.unit})` : ""}</label>
                          {p.type === "dictionary" && p.dictionary?.length > 0 ? (
                            <div>
                              {multipleChoices ? (
                                <div style={{ border: "1px solid #d1d5db", borderRadius: 6, padding: "6px 8px", maxHeight: 160, overflowY: "auto" as const, background: "#fff" }}>
                                  <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 4 }}>Możesz wybrać kilka</div>
                                  {p.dictionary
                                    .filter((d:any) => !(d.id === p.options?.ambiguousValueId && p.options?.describesProduct && !p.options?.customValuesEnabled))
                                    .map((d:any) => {
                                      const checked = selectedIds.includes(d.id);
                                      return (
                                        <label key={d.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "3px 0", cursor: "pointer", fontSize: 12 }}>
                                          <input type="checkbox" checked={checked} onChange={e => {
                                            const newIds = e.target.checked
                                              ? [...selectedIds, d.id]
                                              : selectedIds.filter((x:string) => x !== d.id);
                                            setParamValues(pv => ({...pv, [p.id]: newIds as unknown as string}));
                                          }} />
                                          {d.name}
                                        </label>
                                      );
                                    })}
                                </div>
                              ) : (
                                <select style={s.input} value={paramValues[p.id]||""} onChange={e => setParamValues(pv=>({...pv,[p.id]:e.target.value}))}>
                                  <option value="">-- pomijam --</option>
                                  {p.dictionary
                                    .filter((d:any) => !(d.id === p.options?.ambiguousValueId && p.options?.describesProduct && !p.options?.customValuesEnabled))
                                    .map((d:any) => <option key={d.id} value={d.id}>{d.name}</option>)}
                                </select>
                              )}
                              {!multipleChoices && p.options?.ambiguousValueId && paramValues[p.id] === p.options.ambiguousValueId && p.options?.customValuesEnabled && (
                                <input style={{...s.input, marginTop: 4, borderColor: "#f59e0b"}} value={paramCustomValues[p.id]||""} onChange={e => setParamCustomValues(pv=>({...pv,[p.id]:e.target.value}))} placeholder={`Podaj własną wartość dla "${p.name}"...`} />
                              )}
                            </div>
                          ) : p.restrictions?.range === true ? (
                            <div style={{display:"flex",gap:6,alignItems:"center"}}>
                              <input style={s.input} type="number" value={paramValues[p.id]?.from||""} placeholder={`od${p.restrictions?.min!=null?` (min ${p.restrictions.min})`:""}`}
                                onChange={e => setParamValues(pv=>({...pv,[p.id]:{...(pv[p.id]||{}),from:e.target.value}}))} />
                              <span style={{fontSize:12,color:"#6b7280"}}>–</span>
                              <input style={s.input} type="number" value={paramValues[p.id]?.to||""} placeholder={`do${p.restrictions?.max!=null?` (max ${p.restrictions.max})`:""}`}
                                onChange={e => setParamValues(pv=>({...pv,[p.id]:{...(pv[p.id]||{}),to:e.target.value}}))} />
                            </div>
                          ) : <input style={s.input} value={paramValues[p.id]||""} onChange={e => setParamValues(pv=>({...pv,[p.id]:e.target.value}))} placeholder="Pozostaw puste" />}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Tytuly per konto */}
          <div style={s.card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>
                Tytuły per konto
                {offerMode === "variants" && <span style={{ fontSize: 11, color: "#7c3aed", fontWeight: 400, marginLeft: 6 }}>(nazwa wariantu zostanie dołączona automatycznie)</span>}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                {generatingTitles && <span style={{ fontSize: 11, color: "#7c3aed" }}>⏳ AI generuje tytuły...</span>}
                <button onClick={() => generateAllTitles()} disabled={generatingTitles || !context}
                  style={{ ...s.btn, background: generatingTitles ? "#f3e8ff" : "#7c3aed", color: generatingTitles ? "#7c3aed" : "#fff", border: generatingTitles ? "1px solid #d8b4fe" : "none" }}>
                  {generatingTitles ? "⏳ Generuję..." : "✦ Generuj wszystkie tytuły"}
                </button>
              </div>
            </div>
            {enabledAccounts.map(cfg => (
              <div key={cfg.account_id} style={{ marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <label style={{ ...s.label, marginBottom: 0, color: "#1d4ed8", fontWeight: 600 }}>📦 {cfg.account_name}</label>
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <span style={{ fontSize: 11, color: (cfg.title||"").length > 75 ? "#dc2626" : "#9ca3af" }}>{(cfg.title||"").length}/75</span>
                    <button onClick={() => generateOneTitle(cfg.account_id)} disabled={generatingTitles || !context}
                      style={{ ...s.btn, background: "#f3e8ff", color: "#7c3aed", padding: "2px 8px", fontSize: 11 }}>🔄</button>
                  </div>
                </div>
                <input style={{ ...s.input, borderColor: (cfg.title||"").length > 75 ? "#dc2626" : "#d1d5db" }}
                  value={cfg.title||""} onChange={e => updateConfig(cfg.account_id, "title", e.target.value)}
                  placeholder={offerMode === "variants" ? "Tytuł bazowy (+ nazwa wariantu automatycznie)" : "Tytuł oferty (max 75 znaków)"} maxLength={80} />
              </div>
            ))}
          </div>

          {/* Opis wspolny - tylko gdy NIE tryb wariantow (w wariantach opisy sa per wariant) */}
          {offerMode !== "variants" && (
          <div style={s.card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>Opis</div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <label style={{ fontSize: 12, color: "#6b7280", display: "flex", alignItems: "center", gap: 4, cursor: "pointer" }}>
                  <input type="checkbox" checked={sameDescForAll} onChange={e => setSameDescForAll(e.target.checked)} />
                  Jeden opis dla wszystkich kont
                </label>
              </div>
            </div>
            {sameDescForAll ? (
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 10, marginBottom: 6 }}>
                  {generatingDesc && <span style={{ fontSize: 11, color: "#7c3aed" }}>⏳ AI generuje opis, może potrwać 20-30 sekund...</span>}
                  <button onClick={() => generateOneDesc("")} disabled={generatingDesc || !context}
                    style={{ ...s.btn, background: generatingDesc ? "#f3e8ff" : "#7c3aed", color: generatingDesc ? "#7c3aed" : "#fff", fontSize: 11, border: generatingDesc ? "1px solid #d8b4fe" : "none" }}>
                    {generatingDesc ? "⏳ Generuję..." : "✦ Generuj opis"}
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4 }}>
                  {description && <button onClick={() => setPreviewDesc(description)}
                    style={{ ...s.btn, background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", fontSize: 11 }}>👁 Podgląd</button>}
                </div>
                <textarea value={description} onChange={e => setDescription(e.target.value)} rows={8}
                  placeholder="Opis oferty (HTML) — wspólny dla wszystkich kont"
                  style={{ ...s.input, resize: "vertical" as const, fontFamily: "monospace", fontSize: 12 }} />
              </div>
            ) : (
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                  <button onClick={() => generateAllDescs()} disabled={generatingDesc || !context}
                    style={{ ...s.btn, background: generatingDesc ? "#f3f4f6" : "#7c3aed", color: generatingDesc ? "#374151" : "#fff" }}>
                    {generatingDesc ? "⏳ Generuję..." : "✦ Generuj wszystkie opisy"}
                  </button>
                </div>
                {enabledAccounts.map(cfg => (
                  <div key={cfg.account_id} style={{ marginBottom: 12 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ ...s.label, marginBottom: 0, color: "#1d4ed8", fontWeight: 600 }}>📦 {cfg.account_name}</label>
                      <button onClick={() => generateOneDesc(cfg.account_id)} disabled={generatingDesc || !context}
                        style={{ ...s.btn, background: "#f3e8ff", color: "#7c3aed", padding: "2px 8px", fontSize: 11 }}>🔄</button>
                    </div>
                    {cfg.description && <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4 }}>
                      <button onClick={() => setPreviewDesc(cfg.description)}
                        style={{ ...s.btn, background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", fontSize: 11 }}>👁 Podgląd</button>
                    </div>}
                    <textarea value={cfg.description||""} onChange={e => updateConfig(cfg.account_id, "description", e.target.value)} rows={6}
                      placeholder="Opis oferty (HTML)"
                      style={{ ...s.input, resize: "vertical" as const, fontFamily: "monospace", fontSize: 12 }} />
                  </div>
                ))}
              </div>
            )}
          </div>
          )}

          {/* Dane per wariant: EAN + opis (tylko tryb wariantow) */}
          {offerMode === "variants" && selectedVariantValues.length > 0 && (
            <div style={{ ...s.card, border: "2px solid #e9d5ff", background: "#faf5ff" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, flexWrap: "wrap" as const, gap: 8 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#7c3aed" }}>🎨 Dane per wariant (tytuł, EAN, parametry, opis)</div>
                <button onClick={generateAllVariantData} disabled={generatingVariantData || !context}
                  style={{ ...s.btn, background: generatingVariantData ? "#f3f4f6" : "#7c3aed", color: generatingVariantData ? "#374151" : "#fff", fontSize: 12, fontWeight: 700 }}>
                  {generatingVariantData ? "⏳ Generuję wszystko (tytuły, opisy, EAN)..." : "✦ Generuj wszystko dla wariantów (tytuły + opisy + EAN)"}
                </button>
              </div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 10 }}>
                EAN wyciągany z kontekstu per wariant (możesz edytować). Opis — osobny dla każdego wariantu (dotyczy tylko tego wariantu). Puste pola = użyty wspólny opis.
              </div>
              {selectedVariantValues.map(v => (
                <div key={v.id} style={{ marginBottom: 14, paddingBottom: 14, borderBottom: "1px solid #e9d5ff" }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#7c3aed", marginBottom: 6 }}>🎨 {v.name}</div>
                  {/* Tytul per wariant (puste = tytul bazowy per konto + nazwa wariantu) */}
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                    <label style={{ fontSize: 11, color: "#6b7280", minWidth: 40 }}>Tytuł:</label>
                    <input style={{ ...s.input }} value={variantTitle[v.id] || ""}
                      onChange={e => setVariantTitle(prev => ({ ...prev, [v.id]: e.target.value }))}
                      placeholder="Puste = tytuł bazowy konta + nazwa wariantu" maxLength={75} />
                    <button onClick={() => generateOneVariantTitle(v.id, v.name)} disabled={generatingVariantData || !context}
                      style={{ ...s.btn, background: "#f3e8ff", color: "#7c3aed", fontSize: 11, whiteSpace: "nowrap" as const }}>✦ Generuj</button>
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                    <label style={{ fontSize: 11, color: "#6b7280", minWidth: 40 }}>EAN:</label>
                    <input style={{ ...s.input, maxWidth: 260 }} value={variantEan[v.id] || ""}
                      onChange={e => setVariantEan(prev => ({ ...prev, [v.id]: e.target.value }))}
                      placeholder="np. 5901234123457" />
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6, flexWrap: "wrap" as const }}>
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <label style={{ fontSize: 11, color: "#6b7280" }}>SKU:</label>
                      <input style={{ ...s.input, maxWidth: 160 }} value={variantSku[v.id] || ""}
                        onChange={e => setVariantSku(prev => ({ ...prev, [v.id]: e.target.value }))}
                        placeholder="puste = wspólny + wariant" />
                    </div>
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <label style={{ fontSize: 11, color: "#6b7280" }}>Cena:</label>
                      <input type="number" min="0" step="0.01" style={{ ...s.input, maxWidth: 100 }} value={variantPrice[v.id] || ""}
                        onChange={e => setVariantPrice(prev => ({ ...prev, [v.id]: e.target.value }))}
                        placeholder="wspólna" />
                    </div>
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <label style={{ fontSize: 11, color: "#6b7280" }}>Stan:</label>
                      <input type="number" min="0" style={{ ...s.input, maxWidth: 80 }} value={variantStock[v.id] || ""}
                        onChange={e => setVariantStock(prev => ({ ...prev, [v.id]: e.target.value }))}
                        placeholder="wspólny" />
                    </div>
                  </div>
                  {/* Nadpisania parametrow per wariant - sprzedawca wybiera ktore parametry sie roznia */}
                  <div style={{ marginBottom: 6 }}>
                    <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4 }}>Parametry różniące się dla tego wariantu (np. nr katalogowy):</div>
                    {Object.entries(variantParamOverrides[v.id] || {}).map(([pid, pval]) => {
                      const pdef = allCategoryParams.find((p: any) => p.id === pid);
                      return (
                        <div key={pid} style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 4 }}>
                          <span style={{ fontSize: 11, minWidth: 140, color: "#374151" }}>{pdef?.name || pid}:</span>
                          {pdef?.dictionary?.length > 0 ? (
                            <select style={{ ...s.input, maxWidth: 220 }} value={pval}
                              onChange={e => setVariantParamOverrides(prev => ({ ...prev, [v.id]: { ...(prev[v.id]||{}), [pid]: e.target.value } }))}>
                              <option value="">— wybierz —</option>
                              {pdef.dictionary.map((d: any) => <option key={d.id} value={d.id}>{d.name}</option>)}
                            </select>
                          ) : (
                            <input style={{ ...s.input, maxWidth: 220 }} value={pval}
                              onChange={e => setVariantParamOverrides(prev => ({ ...prev, [v.id]: { ...(prev[v.id]||{}), [pid]: e.target.value } }))}
                              placeholder="wartość dla tego wariantu" />
                          )}
                          <button onClick={() => setVariantParamOverrides(prev => { const next = { ...prev }; selectedVariantValues.forEach(sv => { const c = { ...(next[sv.id]||{}) }; delete c[pid]; next[sv.id] = c; }); return next; })}
                            style={{ ...s.btn, background: "#fee2e2", color: "#dc2626", border: "1px solid #fca5a5", fontSize: 10, padding: "2px 6px" }}>✕</button>
                        </div>
                      );
                    })}
                    <select style={{ ...s.input, maxWidth: 260, fontSize: 11 }} value=""
                      onChange={e => { const pid = e.target.value; if (pid) setVariantParamOverrides(prev => { const next = { ...prev }; selectedVariantValues.forEach(sv => { next[sv.id] = { ...(next[sv.id]||{}), [pid]: (next[sv.id]||{})[pid] || "" }; }); return next; }); }}>
                      <option value="">+ dodaj parametr różniący się...</option>
                      {allCategoryParams.filter((p: any) => !(variantParamOverrides[v.id] || {})[p.id]).map((p: any) => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ fontSize: 11, color: "#6b7280" }}>Opis wariantu:</label>
                    <div style={{ display: "flex", gap: 6 }}>
                      {variantDesc[v.id] && (
                        <button onClick={() => setPreviewDesc(variantDesc[v.id])}
                          style={{ ...s.btn, background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", fontSize: 11 }}>👁 Podgląd</button>
                      )}
                      <button onClick={() => generateOneVariantDesc(v.id, v.name)} disabled={generatingVariantData || !context}
                        style={{ ...s.btn, background: "#f3e8ff", color: "#7c3aed", fontSize: 11 }}>✦ Generuj opis</button>
                    </div>
                  </div>
                  <textarea value={variantDesc[v.id] || ""} onChange={e => setVariantDesc(prev => ({ ...prev, [v.id]: e.target.value }))} rows={4}
                    placeholder="Opis dla tego wariantu (puste = wspólny opis). HTML."
                    style={{ ...s.input, resize: "vertical" as const, fontFamily: "monospace", fontSize: 12 }} />
                </div>
              ))}
            </div>
          )}

          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => setStep(2)} style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" }}>← Wstecz</button>
            <button onClick={() => goToStep(4)} style={{ ...s.btn, background: "#1d4ed8", color: "#fff" }}>Dalej →</button>
          </div>
        </div>
      )}

      {/* KROK 4 — Warunki */}
      {step === 4 && (
        <div>

          {/* WSPOLNE dla wszystkich kont */}
          <div style={{ background: "#fffbeb", border: "1px solid #fcd34d", borderRadius: 8, padding: 16, marginBottom: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: "#92400e" }}>📋 Wartości wspólne dla wszystkich kont</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <div>
                <label style={s.label}>Czas wysyłki</label>
                <select style={s.input} value={enabledAccounts[0]?.handling_time || "PT0S"}
                  onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, handling_time: e.target.value})))}>
                  {HANDLING_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Faktura</label>
                <select style={s.input} value={enabledAccounts[0]?.invoice || "VAT"}
                  onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, invoice: e.target.value})))}>
                  {INVOICE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div style={{ gridColumn: "1 / -1" }}>
                <label style={s.label}>Lokalizacja</label>
                <div style={{ display: "flex", gap: 6, marginBottom: 4 }}>
                  <input style={{ ...s.input, flex: 2 }} value={enabledAccounts[0]?.location_city || ""}
                    onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, location_city: e.target.value})))} placeholder="Miasto" />
                  <input style={{ ...s.input, flex: 1 }} value={enabledAccounts[0]?.location_zip || ""}
                    onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, location_zip: e.target.value})))} placeholder="00-000" />
                </div>
                <select style={s.input} value={enabledAccounts[0]?.location_province || "MAZOWIECKIE"}
                  onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, location_province: e.target.value})))}>
                  {PROVINCE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
            </div>

            {/* GPSR wspolne */}
            <div style={{ borderTop: "1px dashed #fcd34d", marginTop: 12, paddingTop: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#92400e", marginBottom: 8 }}>🛡 GPSR (wspólne)</div>
              {(() => {
                const firstProf = profiles.find(p => p.account_id === enabledAccounts[0]?.account_id)?.profile;
                return (
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <div>
                      <label style={s.label}>Producent odpowiedzialny</label>
                      <select style={s.input} value={enabledAccounts[0]?.responsible_producer_id || ""}
                        onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, responsible_producer_id: e.target.value})))}>
                        <option value="">-- brak --</option>
                        {firstProf?.responsible_producers?.map((r:any) => <option key={r.id} value={r.id}>{r.name}</option>)}
                      </select>
                      {!firstProf?.responsible_producers?.length && <div style={{ fontSize: 11, color: "#f59e0b", marginTop: 3 }}>⚠ Zsynchronizuj profil w Ustawieniach</div>}
                    </div>
                    <div>
                      <label style={s.label}>Osoba odpowiedzialna</label>
                      <select style={s.input} value={enabledAccounts[0]?.responsible_person_id || ""}
                        onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, responsible_person_id: e.target.value})))}>
                        <option value="">-- brak --</option>
                        {firstProf?.responsible_persons?.map((r:any) => <option key={r.id} value={r.id}>{r.name}</option>)}
                      </select>
                    </div>
                    <div style={{ gridColumn: "1 / -1" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                        <label style={s.label}>Informacje o bezpieczeństwie</label>
                        <button onClick={() => setShowSafetyModal(true)}
                          style={{ ...s.btn, background: "#f0fdf4", color: "#15803d", border: "1px solid #bbf7d0", fontSize: 11, padding: "3px 8px" }}>+ Nowy szablon</button>
                      </div>
                      <select style={s.input} value={enabledAccounts[0]?.safety_info_template || ""}
                        onChange={e => {
                          const val = e.target.value;
                          setAccountConfigs(prev => prev.map(c => ({...c, safety_info_template: val})));
                        }}>
                        <option value="">-- brak --</option>
                        {firstProf?.safety_info_templates?.map((t:any, i:number) => <option key={i} value={typeof t === "string" ? t : JSON.stringify(t)}>{typeof t === "string" ? t.substring(0,60) : t.name}</option>)}
                      </select>
                    </div>
                  </div>
                );
              })()}
            </div>

            {/* Pozostale ustawienia wspolne */}
            <div style={{ borderTop: "1px dashed #fcd34d", marginTop: 12, paddingTop: 12, display: "flex", flexDirection: "column" as const, gap: 10 }}>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer" }}>
                <input type="checkbox" checked={enabledAccounts[0]?.marketed_before_gpsr || false}
                  onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, marketed_before_gpsr: e.target.checked})))}
                  style={{ marginTop: 2, width: 16, height: 16 }} />
                <span style={{ fontSize: 12, color: "#374151" }}>
                  <strong>Oświadczam</strong>, że produkt wprowadzono do obrotu w UE przed 13 grudnia 2024 r. i jest zgodny z ówczesnymi przepisami bezpieczeństwa
                </span>
              </label>
              <div>
                <label style={s.label}>Czas trwania oferty</label>
                <select style={s.input} value={enabledAccounts[0]?.publication_duration || ""}
                  onChange={e => setAccountConfigs(prev => prev.map(c => ({...c, publication_duration: e.target.value})))}>
                  <option value="">Bezterminowo (do wyczerpania)</option>
                  <option value="P3D">3 dni</option>
                  <option value="P5D">5 dni</option>
                  <option value="P7D">7 dni</option>
                  <option value="P10D">10 dni</option>
                  <option value="P14D">14 dni</option>
                  <option value="P30D">30 dni</option>
                </select>
              </div>
            </div>
          </div>

          {/* PER KONTO — tylko cennik, zwroty, reklamacje, gwarancja */}
          {enabledAccounts.map(cfg => {
            const prof = profiles.find(p => p.account_id === cfg.account_id)?.profile;
            return (
              <div key={cfg.account_id} style={s.card}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: "#1d4ed8" }}>📦 {cfg.account_name}</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <label style={s.label}>Cennik dostawy *</label>
                    <select style={s.input} value={cfg.shipping_rates_id} onChange={e => updateConfig(cfg.account_id, "shipping_rates_id", e.target.value)}>
                      <option value="">-- brak --</option>
                      {prof?.shipping_rates?.map((r: any) => <option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                    {!prof?.shipping_rates?.length && <div style={{ fontSize: 11, color: "#f59e0b", marginTop: 3 }}>⚠ Zsynchronizuj profil w Ustawieniach</div>}
                  </div>
                  <div>
                    <label style={s.label}>Warunki zwrotów *</label>
                    <select style={s.input} value={cfg.return_policy_id} onChange={e => updateConfig(cfg.account_id, "return_policy_id", e.target.value)}>
                      <option value="">-- brak --</option>
                      {prof?.return_policies?.map((r:any) => <option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={s.label}>Reklamacje (rękojmia) *</label>
                    <select style={s.input} value={cfg.implied_warranty_id} onChange={e => updateConfig(cfg.account_id, "implied_warranty_id", e.target.value)}>
                      <option value="">-- brak --</option>
                      {prof?.implied_warranties?.map((r:any) => <option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={s.label}>Gwarancja</label>
                    <select style={s.input} value={cfg.warranty_id} onChange={e => updateConfig(cfg.account_id, "warranty_id", e.target.value)}>
                      <option value="">-- brak --</option>
                      {prof?.warranties?.map((r:any) => <option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            );
          })}

          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => setStep(3)} style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" }}>← Wstecz</button>
            <button onClick={() => goToStep(5)} style={{ ...s.btn, background: "#1d4ed8", color: "#fff" }}>Dalej →</button>
          </div>
        </div>
      )}

      {/* KROK 5 — Cena, stan, wystawianie */}
      {step === 5 && (
        <div>
          {enabledAccounts.map(cfg => (
            <div key={cfg.account_id} style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: "#1d4ed8" }}>📦 {cfg.account_name}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                <div>
                  <label style={s.label}>Sygnatura / SKU</label>
                  {(() => { const perVar = offerMode === "variants" && selectedVariantValues.some(v => (variantSku[v.id]||"").trim()); return (
                    <>
                    <input style={{ ...s.input, background: perVar ? "#f3f4f6" : "#fff" }} disabled={perVar} value={perVar ? "" : cfg.sku} onChange={e => updateConfig(cfg.account_id, "sku", e.target.value)} onBlur={e => !perVar && autofillOthers(cfg.account_id, "sku", e.target.value)} placeholder={perVar ? "ustawione per wariant" : "np. LED-BMW-F10-DRL"} />
                    {perVar && <div style={{ fontSize: 10, color: "#7c3aed", marginTop: 2 }}>SKU ustawione per wariant (sekcja Dane per wariant)</div>}
                    </>
                  ); })()}
                  {offerMode === "variants" && cfg.sku && <div style={{ fontSize: 10, color: "#7c3aed", marginTop: 2 }}>→ per wariant: {cfg.sku}-[wariant]</div>}
                </div>
                <div>
                  <label style={s.label}>Cena (PLN) *</label>
                  {(() => { const perVar = offerMode === "variants" && selectedVariantValues.some(v => (variantPrice[v.id]||"").trim()); return (
                    <>
                    <input type="number" min="0" step="0.01" style={{ ...s.input, background: perVar ? "#f3f4f6" : "#fff" }} disabled={perVar} value={perVar ? "" : cfg.price} onChange={e => updateConfig(cfg.account_id, "price", e.target.value)} onBlur={e => !perVar && autofillOthers(cfg.account_id, "price", e.target.value)} placeholder={perVar ? "ustawione per wariant" : "np. 29.99"} />
                    {perVar && <div style={{ fontSize: 10, color: "#7c3aed", marginTop: 2 }}>Cena ustawiona per wariant</div>}
                    </>
                  ); })()}
                </div>
                <div>
                  <label style={s.label}>Stan (szt.) *</label>
                  {(() => { const perVar = offerMode === "variants" && selectedVariantValues.some(v => (variantStock[v.id]||"").trim()); return (
                    <>
                    <input type="number" min="1" style={{ ...s.input, background: perVar ? "#f3f4f6" : "#fff" }} disabled={perVar} value={perVar ? "" : cfg.stock} onChange={e => updateConfig(cfg.account_id, "stock", e.target.value)} onBlur={e => !perVar && autofillOthers(cfg.account_id, "stock", e.target.value)} placeholder={perVar ? "ustawione per wariant" : "np. 100"} />
                    {perVar && <div style={{ fontSize: 10, color: "#7c3aed", marginTop: 2 }}>Stan ustawiony per wariant</div>}
                    </>
                  ); })()}
                  {offerMode === "variants" && <div style={{ fontSize: 10, color: "#7c3aed", marginTop: 2 }}>Stan per wariant</div>}
                </div>
              </div>
              {(()=>{
                const modelP=allCategoryParams.find((p:any)=>["237206","234493","243973","249034"].includes(p.id));
                const zamP=allCategoryParams.find((p:any)=>p.id==="215941");
                const orgP=allCategoryParams.find((p:any)=>p.id==="227345");
                if(!modelP&&!zamP&&!orgP) return null;
                return <div style={{marginTop:10,borderTop:"1px dashed #e5e7eb",paddingTop:10}}>
                  <div style={{fontSize:11,color:"#6b7280",marginBottom:6}}>Parametry roznicujace (unikalne per konto)</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
                    {modelP&&<div><label style={s.label}>{modelP.name}</label><input style={s.input} value={cfg.param_model||""} onChange={e=>updateConfig(cfg.account_id,"param_model",e.target.value)} onBlur={e=>autofillOthers(cfg.account_id,"param_model",e.target.value)} placeholder="np. 1234M"/></div>}
                    {zamP&&<div><label style={s.label}>Nr zamiennika</label><input style={s.input} value={cfg.param_zamienniki||""} onChange={e=>updateConfig(cfg.account_id,"param_zamienniki",e.target.value)} onBlur={e=>autofillOthers(cfg.account_id,"param_zamienniki",e.target.value)} placeholder="np. 1234Z"/></div>}
                    {orgP&&<div><label style={s.label}>Nr oryginalu</label><input style={s.input} value={cfg.param_oryginal||""} onChange={e=>updateConfig(cfg.account_id,"param_oryginal",e.target.value)} onBlur={e=>autofillOthers(cfg.account_id,"param_oryginal",e.target.value)} placeholder="np. 1234O"/></div>}
                  </div>
                </div>;
              })()}
            </div>
          ))}

          {/* NEW: Podsumowanie wariantów */}
          {offerMode === "variants" && selectedVariantValues.length > 0 && (
            <div style={{ background: "#faf5ff", border: "1px solid #e9d5ff", borderRadius: 8, padding: 12, marginBottom: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: "#7c3aed" }}>🎨 Podsumowanie wariantów</div>
              <div style={{ fontSize: 12, color: "#374151", lineHeight: 2 }}>
                <div>Parametr: <strong>{variantParam?.name}</strong></div>
                <div style={{ marginBottom: 6 }}>Warianty ({selectedVariantValues.length}) — dane per wariant:</div>
                <div style={{ display: "flex", flexDirection: "column" as const, gap: 4, marginBottom: 6 }}>
                  {selectedVariantValues.map(v => {
                    const perAccV = variantImages[v.id] || {};
                    const imgCount = Object.values(perAccV).filter((x: any) => x && (x.main || (x.extra && x.extra.length > 0))).length;
                    const hasEan = !!(variantEan[v.id] || "").trim();
                    const hasTitle = !!(variantTitle[v.id] || "").trim();
                    const hasDesc = !!(variantDesc[v.id] || "").trim();
                    const ovCount = Object.values(variantParamOverrides[v.id] || {}).filter((x: any) => String(x||"").trim()).length;
                    const chip = (ok: boolean, label: string) => (
                      <span style={{ background: ok ? "#dcfce7" : "#f3f4f6", color: ok ? "#166534" : "#9ca3af", borderRadius: 4, padding: "1px 6px", fontSize: 10 }}>{ok ? "✓" : "○"} {label}</span>
                    );
                    return (
                      <div key={v.id} style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" as const, background: "#fff", borderRadius: 6, padding: "4px 8px", border: "1px solid #e9d5ff" }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: "#7c3aed", minWidth: 90 }}>🎨 {v.name}</span>
                        {chip(imgCount > 0, `zdjęcia (${imgCount} kont)`)}
                        {chip(hasEan, "EAN")}
                        {chip(hasTitle, "tytuł")}
                        {chip(hasDesc, "opis")}
                        {ovCount > 0 && <span style={{ background: "#eef2ff", color: "#4338ca", borderRadius: 4, padding: "1px 6px", fontSize: 10 }}>+{ovCount} param.</span>}
                      </div>
                    );
                  })}
                </div>
                <div>Łącznie ofert do wystawienia: <strong>{selectedVariantValues.length * enabledAccounts.length}</strong></div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
                  ⏱ Czas wystawiania: ~{Math.ceil(selectedVariantValues.length * enabledAccounts.length * 10 / 60)} min (10 sek. przerwa między ofertami)
                </div>
              </div>
            </div>
          )}

          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>💬 Uwagi do zakupu</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer", fontSize: 12 }}>
                <input type="radio" name="messageToSeller" value="OPTIONAL" checked={messageToSeller === "OPTIONAL"}
                  onChange={() => setMessageToSeller("OPTIONAL")} style={{ marginTop: 2 }} />
                <span>Na wszelki wypadek pozostawiam możliwość dodania uwag do zakupu — <strong>opcjonalne pole "uwagi do zakupu"</strong></span>
              </label>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer", fontSize: 12 }}>
                <input type="radio" name="messageToSeller" value="HIDDEN" checked={messageToSeller === "HIDDEN"}
                  onChange={() => setMessageToSeller("HIDDEN")} style={{ marginTop: 2 }} />
                <span>Nie potrzebuję żadnych informacji — <strong>brak pola "uwagi do zakupu"</strong></span>
              </label>
            </div>
          </div>
          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>🔄 Wznawianie oferty</div>
            <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer", fontSize: 12 }}>
              <input type="checkbox" checked={republish} onChange={e => setRepublish(e.target.checked)}
                style={{ marginTop: 2, width: 16, height: 16 }} />
              <span>Po zakończeniu wystaw ponownie ofertę z pełną liczbą sztuk</span>
            </label>
          </div>
          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>🧾 Stawki VAT</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: 8 }}>
              {[{code:"PL",label:"Polska"},{code:"CZ",label:"Czechy"},{code:"SK",label:"Słowacja"},{code:"HU",label:"Węgry"},{code:"LT",label:"Litwa"}].map(c => (
                <div key={c.code}>
                  <label style={s.label}>{c.label} ({c.code})</label>
                  <input style={s.input} value={vatRates[c.code]||""} onChange={e => setVatRates(prev => ({...prev, [c.code]: e.target.value}))} placeholder="np. 23.00" />
                </div>
              ))}
            </div>
          </div>
          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>🌍 Rynki sprzedaży</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {MARKETPLACES.map(m => (
                <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 12 }}>
                  <input type="checkbox"
                    checked={selectedMarketplaces.includes(m.id)}
                    onChange={e => {
                      if (m.id === "allegro-pl") return;
                      setSelectedMarketplaces(prev =>
                        e.target.checked ? [...prev, m.id] : prev.filter(x => x !== m.id)
                      );
                    }}
                    disabled={m.id === "allegro-pl"}
                    style={{ width: 14, height: 14 }} />
                  {m.label}
                </label>
              ))}
            </div>
          </div>
          <div style={s.card}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Podsumowanie</div>
            <div style={{ fontSize: 12, color: "#374151", lineHeight: 2 }}>
              <div>🏷 <strong>Tytuł:</strong> {(() => {
                const base = enabledAccounts[0]?.title || title || "";
                const everyVar = offerMode === "variants" && selectedVariantValues.length > 0 && selectedVariantValues.every(v => (variantTitle[v.id]||"").trim());
                if (base) return <>{base}{offerMode === "variants" && <span style={{ color: "#7c3aed" }}> + [wariant]</span>}</>;
                if (everyVar) return <span style={{ color: "#7c3aed" }}>ustawiony per wariant</span>;
                return <span style={{ color: "#dc2626" }}>Brak!</span>;
              })()}</div>
              <div>📂 <strong>Kategoria:</strong> {categoryName || <span style={{ color: "#dc2626" }}>Brak!</span>}</div>
              <div>🖼 <strong>Zdjęcia:</strong> {uploadedImages.length} szt. w bazie</div>
              <div>🏢 <strong>Konta:</strong> {enabledAccounts.map(c=>c.account_name).join(", ")}</div>
              {offerMode === "variants" && (
                <div>🎨 <strong>Tryb:</strong> Warianty ({selectedVariantValues.length} × {enabledAccounts.length} = <strong>{selectedVariantValues.length * enabledAccounts.length} ofert</strong>)</div>
              )}
            </div>
          </div>

          {publishResults.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              {publishResults.map((r, i) => (
                <div key={i} style={{ background: (r.status===201||r.status===202) ? "#f0fdf4" : "#fef2f2", border: `1px solid ${(r.status===201||r.status===202)?"#bbf7d0":"#fecaca"}`, borderRadius: 8, padding: 12, marginBottom: 6 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: (r.status===201||r.status===202) ? "#15803d" : "#dc2626" }}>
                    {(r.status===201||r.status===202) ? "✓" : "✗"} {r.account}{r.variant ? <span style={{ color: "#7c3aed" }}> / {r.variant}</span> : ""}
                  </div>
                  {r.offer_id && <div style={{ fontSize: 12 }}>ID: {r.offer_id} · <a href={`https://allegro.pl/oferta/${r.offer_id}`} target="_blank" rel="noreferrer" style={{ color: "#1d4ed8" }}>Otwórz →</a></div>}
                  {r.error && <div style={{ fontSize: 12, color: "#dc2626" }}>{r.error}</div>}
                  {r.errors?.map((e: any, j: number) => <div key={j} style={{ fontSize: 12, color: "#dc2626" }}>• {e.userMessage || e.message}</div>)}
                  {r.raw?.errors?.map((e: any, j: number) => <div key={j} style={{ fontSize: 12, color: "#dc2626" }}>• {e.userMessage || e.message} {e.path ? `(${e.path})` : ""}</div>)}
                  {r.raw?.validation?.errors?.map((e: any, j: number) => <div key={j} style={{ fontSize: 12, color: "#dc2626" }}>• {e.userMessage || e.message} {e.path ? `(${e.path})` : ""}</div>)}
                  {(r.status !== 201 && r.status !== 202) && !r.error && !r.errors?.length && !r.raw?.errors?.length && (
                    <details style={{ marginTop: 4 }}><summary style={{ fontSize: 11, color: "#6b7280", cursor: "pointer" }}>Szczegóły (status {r.status})</summary>
                      <pre style={{ fontSize: 10, overflow: "auto", maxHeight: 200, background: "#f9fafb", padding: 6, borderRadius: 4 }}>{JSON.stringify(r.raw, null, 2)}</pre>
                    </details>
                  )}
                </div>
              ))}
            </div>
          )}

          {publishError && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 6, padding: 10, marginBottom: 12, fontSize: 12, color: "#dc2626" }}>{publishError}</div>}

          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => setStep(4)} style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" }}>← Wstecz</button>
            <button onClick={() => {
                const missing5 = enabledAccounts.filter(c => !c.price || parseFloat(c.price) <= 0);
                if (missing5.length > 0) { alert("Uzupełnij cenę dla kont: " + missing5.map((c:any) => c.account_name).join(", ")); return; }
                const missingStock = enabledAccounts.filter(c => !c.stock || parseInt(c.stock) <= 0);
                if (missingStock.length > 0) { alert("Uzupełnij ilość dla kont: " + missingStock.map((c:any) => c.account_name).join(", ")); return; }
                publish(true);
              }} disabled={publishing} style={{ ...s.btn, background: "#f59e0b", color: "#fff", opacity: publishing?0.5:1 }}>
              {publishing ? "⏳..." : "💾 Szkic"}
            </button>
            <button onClick={() => {
                const missing5 = enabledAccounts.filter(c => !c.price || parseFloat(c.price) <= 0);
                if (missing5.length > 0) { alert("Uzupełnij cenę dla kont: " + missing5.map((c:any) => c.account_name).join(", ")); return; }
                const missingStock = enabledAccounts.filter(c => !c.stock || parseInt(c.stock) <= 0);
                if (missingStock.length > 0) { alert("Uzupełnij ilość dla kont: " + missingStock.map((c:any) => c.account_name).join(", ")); return; }
                publish(false);
              }} disabled={publishing} style={{ ...s.btn, background: "#15803d", color: "#fff", opacity: publishing?0.5:1, padding: "7px 20px" }}>
              {publishing ? "⏳ Wystawiam..." : offerMode === "variants" ? `Wystaw ${selectedVariantValues.length * enabledAccounts.length} ofert` : "Wystaw"}
            </button>
          </div>
        </div>
      )}

      {/* Modal dodawania safety info */}
      {showSafetyModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1001, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          onClick={() => setShowSafetyModal(false)}>
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, maxWidth: 600, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Nowy szablon informacji o bezpieczeństwie</div>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 12 }}>Szablon zostanie zapisany w profilu sprzedażowym i będzie dostępny do wyboru przy wystawianiu ofert.</div>
            <input value={newSafetyName || ""} onChange={e => setNewSafetyName(e.target.value)}
              placeholder="Nazwa szablonu (np. Standardowe ostrzeżenia LED)"
              style={{ ...s.input, marginBottom: 8 }} />
            <textarea value={newSafetyText} onChange={e => setNewSafetyText(e.target.value)} rows={5}
              placeholder="Treść informacji o bezpieczeństwie produktu..."
              style={{ ...s.input, resize: "vertical" as const, fontFamily: "system-ui", marginBottom: 12 }} />
            <div style={{ display: "flex", gap: 8 }}>
              <button disabled={savingSafety || !newSafetyText.trim()} onClick={async () => {
                setSavingSafety(true);
                try {
                  const firstAccount = enabledAccounts[0];
                  if (firstAccount) {
                    const prof = profiles.find((p:any) => p.account_id === firstAccount.account_id)?.profile;
                    const existing = prof?.safety_info_templates || [];
                    const newTemplate = {name: newSafetyName.trim(), text: newSafetyText.trim()};
                    await axios.patch(`${API}/sales-profiles/${firstAccount.account_id}`, {
                      safety_info_templates: [...existing, newTemplate]
                    });
                    const r = await axios.get(API + "/sales-profiles");
                    setProfiles(r.data || []);
                    const newTemplate2 = {name: newSafetyName.trim(), text: newSafetyText.trim()};
                    enabledAccounts.forEach(cfg => {
                      updateConfig(cfg.account_id, "safety_info_template", JSON.stringify(newTemplate2));
                    });
                  }
                  setNewSafetyText("");
                  setNewSafetyName("");
                  setShowSafetyModal(false);
                } catch {}
                setSavingSafety(false);
              }} style={{ ...s.btn, background: "#1d4ed8", color: "#fff", flex: 1, opacity: !newSafetyText.trim() ? 0.5 : 1 }}>
                {savingSafety ? "Zapisuję..." : "Zapisz i użyj"}
              </button>
              <button onClick={() => { setShowSafetyModal(false); setNewSafetyText(""); }}
                style={{ ...s.btn, background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" }}>Anuluj</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal podgladu opisu */}
      {previewDesc && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          onClick={() => setPreviewDesc(null)}>
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, maxWidth: 800, width: "100%", maxHeight: "80vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 15, fontWeight: 700 }}>Podgląd opisu</div>
              <button onClick={() => setPreviewDesc(null)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#6b7280" }}>✕</button>
            </div>
            <div style={{ fontSize: 13, lineHeight: 1.6, color: "#374151" }} dangerouslySetInnerHTML={{ __html: previewDesc }} />
          </div>
        </div>
      )}
    </div>
  );
}
